/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unneeded-ternary */
import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get, orderBy, isNumber } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { ToggleButton } from 'primereact/togglebutton';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from 'primereact/autocomplete';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import moment from 'moment';

import * as actions from '../../../store/modules/auth/actions';

import { displayErrors, converteData, replaceAll, formataDataMoment, formataMoeda, arredondar } from '../../../util/diversos';
import { Input100px, Input155px, Input200px, Input250px, Input400px } from '../../../styles/inputGroup';
import { fillColumns } from '../../../components/table';

import { obterListaMdfeModalidade } from '../../../services/mdfeModalidade';
import { obterListaMdfeTipoEmitente } from '../../../services/mdfeTipoEmitente';
import { obterListaMdfeTipoEmissao } from '../../../services/mdfeTipoEmissao';
import { obterListaMdfeTipoTransportador } from '../../../services/mdfeTipoTransportador';
import { obterListaMdfeRespSeguro } from '../../../services/mdfeRespSeguro';
import { obterListaMdfeModeloDocFiscal } from '../../../services/mdfeModeloDocFiscal';
import { obterListaMdfeTipoUnidTransporte } from '../../../services/mdfeTipoUnidTransporte';
import { obterListaMdfeTipoUnidCarga } from '../../../services/mdfeTipoUnidCarga';
import { obterListaMdfeIndPag } from '../../../services/mdfeIndPag';
import { obterListaMdfeTpAntecip } from '../../../services/mdfeTpAntecip';
import { obterListaMdfeTpComp } from '../../../services/mdfeTpComp';

import Card from '../../../components/card';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Loading from '../../loading';

import ConsultaVeiculo from '../veiculo/consultaVeiculo';
import ConsultaParticipante from '../participante/consultaParticipante';

export default function CadastroMdfePropria({ payloadCadastro, childToParentConsulta }) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [disableEdicaoEnviada, setDisableEdicaoEnviada] = useState(false);

  const id = get(payloadCadastro, 'id', 0);
  const empresaId = get(payloadCadastro, 'idEmpresa', 0);
  const empresaCnpj = get(payloadCadastro, 'cnpjEmpresa', 0);
  const tipoMovimentacao = get(payloadCadastro, 'tipoMovimentacao', '');
  const propsTipoMovimentacao = get(payloadCadastro, 'propsTipoMovimentacao', '');

  let seriePadrao = get(payloadCadastro, 'seriePadrao', '1');
  if (!seriePadrao) {
    seriePadrao = '1';
  }

  const [ufEmpresa, setUfEmpresa] = useState(get(payloadCadastro, 'uf', ''));

  const [flag, setFlag] = useState('D'); // D = digitada , T = transmitida
  const [chaveAcesso, setChaveAcesso] = useState('');
  const [protocolo, setProtocolo] = useState('');
  const [numeroRecibo, setNumeroRecibo] = useState('');
  const [cnpjEmpresa, setCnpjEmpresa] = useState('');

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabRodoviarioIndex, setActiveTabRodoviarioIndex] = useState(0);
  const [activeTabDocFiscalIndex, setActiveTabDocFiscalIndex] = useState(0);
  const [activeTabDocFiscalTransporteIndex, setActiveTabDocFiscalTransporteIndex] = useState(0);
  const [activeTabMunicipioDescargaIndex, setActiveTabMunicipioDescargaIndex] = useState(0);
  const [activeTabInfPagIndex, setActiveTabInfPagIndex] = useState(0);
  const [activeTabInfPagComponenteIndex, setActiveTabInfPagComponenteIndex] = useState(0);

  const mod = '58';
  const [serie, setSerie] = useState(seriePadrao);
  const [numeroMdf, setNumeroMdf] = useState('0');
  const [dhEmi, setDhEmi] = useState(new Date());
  const [dhIniViagem, setDhIniViagem] = useState(new Date());
  const [tipoEmissao, setTipoEmissao] = useState('NORMAL');
  const [modalidade, setModalidade] = useState('RODOVIARIO');
  const [tipoEmitente, setTipoEmitente] = useState('PRESTADORSERVICOTRANSPORTE');
  const [tipoTransportador, setTipoTransportador] = useState(null);
  const [idVeiculo, setIdVeiculo] = useState('');
  const [placaVeiculo, setPlacaVeiculo] = useState(null);
  const [ufInicio, setUfInicio] = useState('MG');
  const [ufFim, setUfFim] = useState('MG');
  const [listaUf, setListaUf] = useState([]);
  const [rntrc, setRntrc] = useState('');

  const listaTipoEmissao = obterListaMdfeTipoEmissao();

  const [listaMunicipios, setListaMunicipios] = useState([]);
  const [filteredMunicipios, setFilteredMunicipios] = useState(null);
  const [listaMunicipioCarrega, setListaMunicipioCarrega] = useState([]);
  const [editandoMunicipioCarrega, setEditandoMunicipioCarrega] = useState(0);
  const [selectedMunicipioCarrega, setSelectedMunicipioCarrega] = useState(null);
  const [cMunCarrega, setCMunCarrega] = useState('');
  const [xMunCarrega, setXMuncarrega] = useState('');

  const [filteredMunicipiosDescarga, setFilteredMunicipiosDescarga] = useState(null);
  const [listaMunicipioDescarga, setListaMunicipioDescarga] = useState([]);
  const [editandoMunicipioDescarga, setEditandoMunicipioDescarga] = useState(0);
  const [selectedMunicipioDescarga, setSelectedMunicipioDescarga] = useState(null);
  const [cMunDescarga, setCMunDescarga] = useState('');
  const [xMunDescarga, setXMunDescarga] = useState('');

  const [listaUfPercurso, setListaUfPercurso] = useState([]);
  const [editandoUfPercurso, setEditandoUfPercurso] = useState(0);
  const [selectedUfPercurso, setSelectedUfPercurso] = useState(null);
  const [ufPercurso, setUfPercurso] = useState('');

  const [listaSeguroCarga, setListaSeguroCarga] = useState([]);
  const [editandoSeguroCarga, setEditandoSeguroCarga] = useState(0);
  const [selectedSeguroCarga, setSelectedSeguroCarga] = useState(null);
  const [seguroResponsavel, setSeguroResponsavel] = useState('EMITENTE');
  const [seguroCnpjResponsavel, setSeguroCnpjResponsavel] = useState('');
  const [seguroNomeSeguradora, setSeguroNomeSeguradora] = useState('');
  const [seguroCnpjSeguradora, setSeguroCnpjSeguradora] = useState('');
  const [seguroNumeroApolice, setSeguroNumeroApolice] = useState('');

  const [listaAverbacao, setListaAverbacao] = useState([]);
  const [editandoAverbacao, setEditandoAverbacao] = useState(0);
  const [selectedAverbacao, setSelectedAverbacao] = useState(null);
  const [numeroAverbacao, setNumeroAverbacao] = useState('');

  const [listaLacreUnidTransporte, setListaLacreUnidTransporte] = useState([]);
  const [editandoLacreUnidTransporte, setEditandoLacreUnidTransporte] = useState(0);
  const [selectedLacreUnidTransporte, setSelectedLacreUnidTransporte] = useState(null);
  const [numeroLacreUnidTransporte, setNumeroLacreUnidTransporte] = useState('');

  const [listaMDFeLacre, setListaMDFeLacre] = useState([]);
  const [editandoMDFeLacre, setEditandoMDFeLacre] = useState(0);
  const [selectedMDFeLacre, setSelectedMDFeLacre] = useState(null);
  const [numeroMDFeLacre, setNumeroMDFeLacre] = useState('');

  const [listaLacreUnidCarga, setListaLacreUnidCarga] = useState([]);
  const [editandoLacreUnidCarga, setEditandoLacreUnidCarga] = useState(0);
  const [selectedLacreUnidCarga, setSelectedLacreUnidCarga] = useState(null);
  const [numeroLacreUnidCarga, setNumeroLacreUnidCarga] = useState('');

  const [listaInfCargaUnidTransporte, setListaInfCargaUnidTransporte] = useState([]);
  const [editandoInfCargaUnidTransporte, setEditandoInfCargaUnidTransporte] = useState(0);
  const [selectedInfCargaUnidTransporte, setSelectedInfCargaUnidTransporte] = useState(null);
  const [tpInfCargaUnidTransporte, setTpInfCargaUnidTransporte] = useState('RODOVIARIOTRACAO');
  const [idInfCargaUnidTransporte, setIdInfCargaUnidTransporte] = useState('');

  const [showConsultaVeiculo, setShowConsultaVeiculo] = useState(false);
  const [showConsultaReboque, setShowConsultaReboque] = useState(false);
  const [showConsultaMunicipio, setShowConsultaMunicipio] = useState(false);
  const [showConsultaMunicipioDescarga, setShowConsultaMunicipioDescarga] = useState(false);
  const [showCadastroMunicipioCarrega, setShowCadastroMunicipioCarrega] = useState(false);
  const [showCadastroMunicipioDescarga, setShowCadastroMunicipioDescarga] = useState(false);
  const [showCadastroUfPercurso, setShowCadastroUfPercurso] = useState(false);
  const [showCadastroSeguroCarga, setShowCadastroSeguroCarga] = useState(false);
  const [showCadastroAverbacao, setShowCadastroAverbacao] = useState(false);
  const [showCadastroLacre, setShowCadastroLacre] = useState(false);
  const [showCadastroLacreUnidTransporte, setShowCadastroLacreUnidTransporte] = useState(false);
  const [showCadastroMDFeLacre, setShowCadastroMDFeLacre] = useState(false);
  const [showCadastroInfCargaUnidTransporte, setShowCadastroInfCargaUnidTransporte] = useState(false);
  const [showCadastroLacreUnidCarga, setShowCadastroLacreUnidCarga] = useState(false);

  const [showConfirmDeleteMunicipioCarrega, setShowConfirmDeleteMunicipioCarrega] = useState(false);
  const [showConfirmDeleteMunicipioDescarga, setShowConfirmDeleteMunicipioDescarga] = useState(false);
  const [showConfirmDeleteUfPercurso, setShowConfirmDeleteUfPercurso] = useState(false);
  const [showConfirmDeleteSeguroCarga, setShowConfirmDeleteSeguroCarga] = useState(false);
  const [showConfirmDeleteAverbacao, setShowConfirmDeleteAverbacao] = useState(false);
  const [showConfirmDeleteLacre, setShowConfirmDeleteLacre] = useState(false);
  const [showConfirmDeleteLacreUnidTransporte, setShowConfirmDeleteLacreUnidTransporte] = useState(false);
  const [showConfirmDeleteMDFeLacre, setShowConfirmDeleteMDFeLacre] = useState(false);
  const [showConfirmDeleteInfCargaUnidTransporte, setShowConfirmDeleteInfCargaUnidTransporte] = useState(false);
  const [showConfirmDeleteLacreUnidCarga, setShowConfirmDeleteLacreUnidCarga] = useState(false);

  const [idDest, setIdDest] = useState(''); // localdestino nota, 1 interna, 2 interestadual, 3 exterior
  const [vOutro, setVOutro] = useState(0);

  const [idParticipante, setIdParticipante] = useState(empresaId);
  const [UfParticipante, setUfParticipante] = useState('');

  const [infCpl, setInfCpl] = useState('');
  const [infAdFisco, setInfAdFisco] = useState('');

  const [listaAutXml, setListaAutXml] = useState([]);
  const [selectedAutXml, setSelectedAutXml] = useState(null);
  const [editandoAutXml, setEditandoAutXml] = useState(0);
  const [autXmlCnpj, setAutXmlCnpj] = useState('');
  const [autXmlCpf, setAutXmlCpf] = useState('');

  const [listaCiot, setListaCiot] = useState([]);
  const [selectedCiot, setSelectedCiot] = useState(null);
  const [editandoCiot, setEditandoCiot] = useState(0);
  const [ciotCodigo, setCiotCodigo] = useState('');
  const [ciotCnpj, setCiotCnpj] = useState('');

  const [listaDocFiscal, setListaDocFiscal] = useState([]);
  const [selectedDocFiscal, setSelectedDocFiscal] = useState(null);
  const [editandoDocFiscal, setEditandoDocFiscal] = useState(0);
  const [docFiscalModelo, setDocFiscalModelo] = useState('55');
  const [docFiscalChaveAcesso, setDocFiscalChaveAcesso] = useState('');
  const [docFiscalSegundoCodigoBarras, setDocFiscalSegundoCodigoBarras] = useState('');
  const [docFiscalReentrega, setDocFiscalReentrega] = useState(false);
  const [docFiscalMunDescarrega, setDocFiscalMunDescarrega] = useState('');
  const [docFiscalXMunDescarrega, setDocFiscalXMunDescarrega] = useState('');
  const [docFiscalUfDescarrega, setDocFiscalUfDescarrega] = useState('AL');

  const [listaDocFiscalTransporte, setListaDocFiscalTransporte] = useState([]);
  const [selectedDocFiscalTransporte, setSelectedDocFiscalTransporte] = useState(null);
  const [editandoDocFiscalTransporte, setEditandoDocFiscalTransporte] = useState(0);
  const [transpTpUnid, setTranspTpUnid] = useState('RODOVIARIOTRACAO');
  const [transpIdUnid, setTranspIdUnid] = useState('');

  const [listaDocFiscalCarga, setListaDocFiscalCarga] = useState([]);
  const [selectedDocFiscalCarga, setSelectedDocFiscalCarga] = useState(null);
  const [editandoDocFiscalCarga, setEditandoDocFiscalCarga] = useState(0);
  const [docFiscalUnidadeCargaTipo, setDocFiscalUnidadeCargaTipo] = useState('CONTAINER'); // ENUM UNID CARGA NO BACKEND
  const [docFiscalUnidadeCargaIdentificacao, setDocFiscalUnidadeCargaIdentificacao] = useState('');
  const [docFiscalUnidadeCargaNLacres, setDocFiscalUnidadeCargaNLacres] = useState('');

  const [listaDocFiscalProdutosPerigosos, setListaDocFiscalProdutosPerigosos] = useState([]);
  const [selectedDocFiscalProdutosPerigosos, setSelectedDocFiscalProdutosPerigosos] = useState(null);
  const [editandoDocFiscalProdutosPerigosos, setEditandoDocFiscalProdutosPerigosos] = useState(0);
  const [docFiscalProdutoPerigosoOnu, setDocFiscalProdutoPerigosoOnu] = useState('');
  const [docFiscalProdutoPerigosoClasse, setDocFiscalProdutoPerigosoClasse] = useState('');
  const [docFiscalProdutoPerigosoNomeEmbarque, setDocFiscalProdutoPerigosoNomeEmbarque] = useState('');
  const [docFiscalProdutoPerigosoGrupoEmbalagem, setDocFiscalProdutoPerigosoGrupoEmbalagem] = useState('');
  const [docFiscalProdutoPerigosoQtdePorProduto, setDocFiscalProdutoPerigosoQtdePorProduto] = useState('');
  const [docFiscalProdutoPerigosoQtdeETipoVolume, setDocFiscalProdutoPerigosoQtdeETipoVolume] = useState('');

  const [listaValePedagio, setListaValePedagio] = useState([]);
  const [selectedValePedagio, setSelectedValePedagio] = useState(null);
  const [editandoValePedagio, setEditandoValePedagio] = useState(0);
  const [valePedagioCnpjForn, setValePedagioCnpjForn] = useState('');
  const [valePedagioCnpjPg, setValePedagioCnpjPg] = useState('');
  const [valePedagioNCompra, setValePedagioNCompra] = useState('');
  const [valePedagioValor, setValePedagioValor] = useState('');

  const [listaInfPag, setListaInfPag] = useState([]);
  const [selectedInfPag, setSelectedInfPag] = useState(null);
  const [editandoInfPag, setEditandoInfPag] = useState(0);
  const [infPagXNome, setInfPagXNome] = useState('');
  const [infPagCpfCnpjResponsavel, setInfPagCpfCnpjResponsavel] = useState('');
  const [infPagIdEstrangeiro, setInfPagIdEstrangeiro] = useState('');
  const [infPagVContrato, setInfPagVContrato] = useState(0);
  const [infPagIndAltoDesemp, setInfPagIndAltoDesemp] = useState(false);
  const [infPagIndPag, setInfPagIndPag] = useState('AVISTA');
  const [infPagVAdiant, setInfPagVAdiant] = useState(0);
  const [infPagIndAntecipaAdiant, setInfPagIndAntecipaAdiant] = useState(false);
  const [infPagTpAntecip, setInfPagTpAntecip] = useState(0);
  const [infPagCodBanco, setInfPagCodBanco] = useState('');
  const [infPagCodAgencia, setInfPagCodAgencia] = useState('');
  const [infPagCnpjIpfe, setInfPagCnpjIpfe] = useState('');
  const [infPagPix, setInfPagPix] = useState('');

  const [listaInfPagComponente, setListaInfPagComponente] = useState([]);
  const [selectedInfPagComponente, setSelectedInfPagComponente] = useState(null);
  const [editandoInfPagComponente, setEditandoInfPagComponente] = useState(0);
  const [infPagTpComp, setInfPagTpComp] = useState('VALEPEDAGIO');
  const [infPagVComp, setInfPagVComp] = useState(0);
  const [infPagXComp, setInfPagXComp] = useState('');

  const [listaInfPagInfPrazo, setListaInfPagInfPrazo] = useState([]);
  const [selectedInfPagInfPrazo, setSelectedInfPagInfPrazo] = useState(null);
  const [editandoInfPagInfPrazo, setEditandoInfPagInfPrazo] = useState(0);
  const [infPagInfPrazoVParcela, setInfPagInfPrazoVParcela] = useState(0);
  const [infPagInfPrazoNParcela, setInfPagInfPrazoNParcela] = useState(1);
  const [infPagInfPrazoDVenc, setInfPagInfPrazoDVenc] = useState(null);

  const [listaContratante, setListaContratante] = useState([]);
  const [selectedContratante, setSelectedContratante] = useState(null);
  const [editandoContratante, setEditandoContratante] = useState(0);
  const [contratanteCnpj, setContratanteCnpj] = useState('');
  const [contratanteCpf, setContratanteCpf] = useState('');

  const [listaReboque, setListaReboque] = useState([]);
  const [selectedReboque, setSelectedReboque] = useState(null);
  const [editandoReboque, setEditandoReboque] = useState(0);
  const [idReboque, setIdReboque] = useState('');
  const [placaReboque, setPlacaReboque] = useState('');

  const [showCadastroAutXml, setShowCadastroAutXml] = useState(false);
  const [showCadastroCiot, setShowCadastroCiot] = useState(false);
  const [showCadastroValePedagio, setShowCadastroValePedagio] = useState(false);
  const [showCadastroInfPag, setShowCadastroInfPag] = useState(false);
  const [showCadastroInfPagComponente, setShowCadastroInfPagComponente] = useState(false);
  const [showCadastroInfPagInfPrazo, setShowCadastroInfPagInfPrazo] = useState(false);
  const [showCadastroContratante, setShowCadastroContratante] = useState(false);
  const [showCadastroReboque, setShowCadastroReboque] = useState(false);
  const [showCadastroDocFiscal, setShowCadastroDocFiscal] = useState(false);
  const [showCadastroDocFiscalTransporte, setShowCadastroDocFiscalTransporte] = useState(false);
  const [showCadastroDocFiscalCarga, setShowCadastroDocFiscalCarga] = useState(false);
  const [showCadastroDocFiscalProdutosPerigosos, setShowCadastroDocFiscalProdutosPerigosos] = useState(false);

  const [showConsultaParticipante, setShowConsultaParticipante] = useState(false);

  const [showConfirmDeleteAutXml, setShowConfirmDeleteAutXml] = useState(false);
  const [showConfirmDeleteCiot, setShowConfirmDeleteCiot] = useState(false);
  const [showConfirmDeleteValePedagio, setShowConfirmDeleteValePedagio] = useState(false);
  const [showConfirmDeleteInfPag, setShowConfirmDeleteInfPag] = useState(false);
  const [showConfirmDeleteInfPagComponente, setShowConfirmDeleteInfPagComponente] = useState(false);
  const [showConfirmDeleteInfPagInfPrazo, setShowConfirmDeleteInfPagInfPrazo] = useState(false);
  const [showConfirmDeleteContratante, setShowConfirmDeleteContratante] = useState(false);
  const [showConfirmDeleteReboque, setShowConfirmDeleteReboque] = useState(false);
  const [showConfirmDeleteDocFiscal, setShowConfirmDeleteDocFiscal] = useState(false);
  const [showConfirmDeleteDocFiscalTransporte, setShowConfirmDeleteDocFiscalTransporte] = useState(false);
  const [showConfirmDeleteDocFiscalCarga, setShowConfirmDeleteDocFiscalCarga] = useState(false);
  const [showConfirmDeleteDocFiscalProdutosPerigosos, setShowConfirmDeleteDocFiscalProdutosPerigosos] = useState(false);

  const [showConfirmEdicaoEnviada, setShowConfirmEdicaoEnviada] = useState(false);
  const [showConfirmCancelarDigitacaoMdfe, setShowConfirmCancelarDigitacaoMdfe] = useState(false);

  const [setListaEmpresas] = useState([]);

  const [columnsSetupMunicipioCarrega] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'cMunCarrega', header: 'Código Município', sort: true },
    { field: 'xMunCarrega', header: 'Nome Município', sort: true },
  ]);

  const [columnsSetupMunicipioDescarga] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'cMunDescarga', header: 'Código Município', sort: true },
    { field: 'xMunDescarga', header: 'Nome Município', sort: true },
  ]);

  const [columnsSetupUfPercurso] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'ufPercurso', header: 'UF', sort: true },
  ]);

  const [columnsSetupAverbacao] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'numeroAverbacao', header: 'Número Averbação', sort: true },
  ]);

  const [columnsSetupLacre] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'numeroLacre', header: 'Número Lacre', sort: true },
  ]);

  const [columnsSetupLacreUnidTransporte] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'numero', header: 'Número Lacre', sort: true },
  ]);

  const [columnsSetupMDFeLacre] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'numero', header: 'Número Lacre', sort: true },
  ]);

  const [columnsSetupLacreUnidCarga] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'numero', header: 'Número Lacre', sort: true },
  ]);

  const [columnsSetupInfCargaUnidTransporte] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'cargaTpUnid', header: 'Tipo', sort: true },
    { field: 'cargaIdUnid', header: 'Identificação', sort: true },
  ]);

  const [columnsSetupSeguroCarga] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'responsavel', header: 'Responsável', sort: true },
    { field: 'cnpjResponsavel', header: 'CNPJ Responsável', sort: true },
    { field: 'nomeSeguradora', header: 'Nome Seguradora', sort: true },
    { field: 'cnpjSeguradora', header: 'CNPJ Seguradora', sort: true },
    { field: 'numeroApolice', header: 'Número Apólice', sort: true },
  ]);

  const [columnsSetupAutXml] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'cnpj', header: 'CNPJ', sort: true },
    { field: 'cpf', header: 'CPF', sort: true },
  ]);

  const [columnsSetupCiot] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'codigo', header: 'Código', sort: true },
    { field: 'cnpj', header: 'CNPJ', sort: true },
    { field: 'cpf', header: 'CPF', sort: true },
  ]);

  const [columnsSetupDocFiscalTransporte] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'transpTpUnid', header: 'Unidade de Transporte', sort: true },
    { field: 'transpIdUnid', header: 'Identificação', sort: true },
  ]);

  const [columnsSetupDocFiscalCarga] = useState([
    { field: 'item', header: 'Item', sort: true },
  ]);

  const [columnsSetupDocFiscalProdutosPerigosos] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'nOnu', header: 'Número ONU', sort: true },
    { field: 'xNomeAe', header: 'Nome Apropriado Embarque', sort: true },
    { field: 'grEmb', header: 'Grupo Embalagem', sort: true },
    { field: 'xClaRisco', header: 'Classificação de Risco', sort: true },
    { field: 'qVolTipo', header: 'Qtde Volume e Tipo', sort: true },
    { field: 'qtdProd', header: 'Qtde de Produto', sort: true },
  ]);

  const [columnsSetupDocFiscal] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'mod', header: 'Modelo', sort: true },
    { field: 'chaveAcesso', header: 'Chave Acesso', sort: true },
    { field: 'segCodBarra', header: 'Segundo Cód Barra', sort: true },
    { field: 'reentrega', header: 'Reentrega', sort: true, booleano: true },
  ]);

  const [columnsSetupValePedagio] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'valePedagioCnpjForn', header: 'CNPJ Fornecedor', sort: true },
    { field: 'valePedagioCnpjPg', header: 'CNPJ Pagamento', sort: true },
    { field: 'valePedagioNCompra', header: 'Número Compra', sort: true },
    { field: 'valePedagioValor', header: 'Valor', sort: true, moeda: true },
  ]);

  const [columnsSetupInfPag] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'xNome', header: 'Nome Responsável', sort: true },
    { field: 'cpfCnpjResponsavel', header: 'Doc. Responsável', sort: true },
    { field: 'vContrato', header: 'Valor do Contrato', sort: true, moeda: true },
  ]);

  const [columnsSetupInfPagComponente] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'tpComp', header: 'Tipo', sort: true },
    { field: 'xComp', header: 'Descrição', sort: true },
    { field: 'vComp', header: 'Valor', sort: true, moeda: true },
  ]);

  const [columnsSetupInfPagInfPrazo] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'dVenc', header: 'Vencimento', sort: true },
    { field: 'nParcela', header: 'Número da Parcela', sort: true },
    { field: 'vParcela', header: 'Valor da Parcela', sort: true, moeda: true },
  ]);

  const [columnsSetupContratante] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'cnpj', header: 'CNPJ', sort: true },
    { field: 'cpf', header: 'CPF', sort: true },
  ]);

  const [columnsSetupReboque] = useState([
    { field: 'id', header: 'id', hidden: true },
    { field: 'item', header: 'Item', sort: true },
    { field: 'placaReboque', header: 'Placa Reboque', sort: true },
  ]);

  const listaMdfeModalidade = obterListaMdfeModalidade();
  const listaMdfeTipoEmitente = obterListaMdfeTipoEmitente();
  const listaMdfeTipoEmissao = obterListaMdfeTipoEmissao();
  const listaMdfeTipoTransportador = obterListaMdfeTipoTransportador();
  const listaRespSeguro = obterListaMdfeRespSeguro();
  const listaMdfeModeloDocFiscal = obterListaMdfeModeloDocFiscal();
  const listaMdfeTipoUnidTrasnporteDocFiscal = obterListaMdfeTipoUnidTransporte();
  const listaMdfeTipoUnidCargaDocFiscal = obterListaMdfeTipoUnidCarga();
  const listaMdfeIndPag = obterListaMdfeIndPag();
  const listaMdfeTpAntecip = obterListaMdfeTpAntecip();
  const listaMdfeTpComp = obterListaMdfeTpComp();

  async function setUltimoNumero(serie) {
    if (id === 0) {
      try {
        setIsLoading(true);

        (serie === '') ? serie = '1' : '';

        await axiosAdmin.get(`/mdfe/ultimonumero?cnpjEmpresa=${empresaCnpj}&mod=${mod}&serie=${serie}`).then(res => {
          const ultimoNumero = res.data;
          if (res.data !== null) {
            const proximoNumero = parseInt(ultimoNumero, 10) + 1;
            setNumeroMdf(proximoNumero.toString());
          }
        }).catch(() => {
          setNumeroMdf(numeroMdf);
        });
      } catch (err) {
        toast.warn('Não foi possível achar o número da nota');
      } finally {
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    let mostrarMensagemErro = true;

    async function getUnidadesFederacao() {
      try {
        setIsLoading(true);

        const listDropdown = [];

        const { data: ufs } = await axiosAdmin.get('/unidadefederacao');

        ufs.forEach(element => {
          listDropdown.push({ label: element.sigla, value: element.sigla });
        });

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaUf(listDropdown);
      } catch (err) {
        if (mostrarMensagemErro) {
          displayErrors(err, dispatch, navigate, '/', '');
        }
        mostrarMensagemErro = false;
      } finally {
        setIsLoading(false);
      }
    }
    getUnidadesFederacao();

    async function getMunicipios() {
      try {
        setIsLoading(true);

        const listDropdown = [];

        const { data: _municipios } = await axiosAdmin.get('/municipio');

        _municipios.forEach(element => {
          listDropdown.push({ label: element.descricao, value: element.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), codigo: element.codigo, uf: element.uf });
        });

        setListaMunicipios(listDropdown);
      } catch (err) {
        if (mostrarMensagemErro) {
          displayErrors(err, dispatch, navigate, '/', '');
        }
        mostrarMensagemErro = false;
      } finally {
        setIsLoading(false);
      }
    }
    getMunicipios();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setUltimoNumero(serie.toString());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serie]);

  useEffect(() => {
    let newTitle = 'MDF-e - Cadastro';
    if (id) {
      newTitle = 'MDF-e - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    const chaveAcesso = get(payloadCadastro, 'chaveAcesso', '');

    if (!id) return; // tipoMovimentacao vem do handleregister do consultamdfe

    const getDataById = async () => {
      const { data } = await axiosAdmin.get(`/mdfe/${id}`);

      // console.log('mdfe: ', data);

      if (data.flag === 'T') {
        setShowConfirmEdicaoEnviada(true);
        setDisableEdicaoEnviada(true);
      }
      return data;
    };

    const setarListaMunicipioCarrega = (data) => {
      let itemMunicipioCarrega = 0;
      const _dataMunicipioCarrega = [];

      data.listaMDFeMunicipioCarrega.forEach(el => {
        itemMunicipioCarrega = itemMunicipioCarrega + 1;
        _dataMunicipioCarrega.push({
          item: itemMunicipioCarrega,
          xMunCarrega: el.xmunCarrega,
          cMunCarrega: el.cmunCarrega,
        });
      });

      setListaMunicipioCarrega(_dataMunicipioCarrega);
    };

    const setarListaUfPercurso = (data) => {
      let itemUfPercurso = 0;
      const _dataUfPercurso = [];

      data.listaMDFeUFPercurso.forEach(el => {
        itemUfPercurso = itemUfPercurso + 1;
        _dataUfPercurso.push({
          item: itemUfPercurso,
          ufPercurso: el.uf,
        });
      });

      setListaUfPercurso(_dataUfPercurso);
    };

    const setarListaLacreUnidTransporte = (data) => {
      let itemLacre = 0;
      const _dataLacre = [];

      // console.log('data setar lista lacre: ', data);

      data.listaMDFeUnidTransporteLacre.forEach(el => {
        itemLacre = itemLacre + 1;
        _dataLacre.push({
          item: itemLacre,
          numeroLacreUnidTransporte: el.numero,
        });
      });

      setListaLacreUnidTransporte(_dataLacre);
    };

    const setarListaMDFeLacre = (data) => {
      let itemLacre = 0;
      const _dataMDFeLacre = [];

      // console.log('data setar mdfe lacre: ', data.listaMDFeLacre);

      data.listaMDFeLacre.forEach(el => {
        itemLacre = itemLacre + 1;
        _dataMDFeLacre.push({
          item: itemLacre,
          numero: el.numero,
        });
      });

      setListaMDFeLacre(_dataMDFeLacre);
    };

    /* const setarListaLacreUnidCarga = (data) => {
      let itemLacre = 0;
      const _dataLacre = [];

      // console.log('data setar lista lacre: ', data);

      data.listaMDFeUnidCargaLacre.forEach(el => {
        itemLacre = itemLacre + 1;
        _dataLacre.push({
          item: itemLacre,
          numeroLacreUnidCarga: el.numero,
        });
      });

      setListaLacreUnidCarga(_dataLacre);
    }; */

    const setarListaInfCargaUnidTransporte = (data) => {
      let itemInf = 0;
      const _dataInf = [];

      data.listaMDFeUnidTransporteInfCarga.forEach(el => {
        itemInf = itemInf + 1;
        _dataInf.push({
          item: itemInf,
          tpUnidCarga: el.tpUniCarga,
          idUnidCarga: el.idUnidCarga,
        });
      });

      setListaInfCargaUnidTransporte(_dataInf);
    };

    const setarListaSeguroCarga = (data) => {
      let itemSeguroCarga = 0;
      const _dataSeguroCarga = [];

      data.listaMDFeSeguro.forEach(el => {
        let itemAverbacao = 0;
        const _dataAverbacao = [];

        el.listaMDFeSeguroAverbacao.forEach(el => {
          itemAverbacao = itemAverbacao + 1;
          _dataAverbacao.push({
            item: itemAverbacao,
            numeroAverbacao: el.numero,
          });
        });

        itemSeguroCarga = itemSeguroCarga + 1;
        _dataSeguroCarga.push({
          item: itemSeguroCarga,
          responsavel: el.responsavel,
          cnpjResponsavel: el.cnpjResponsavel,
          nomeSeguradora: el.nomeSeguradora,
          cnpjSeguradora: el.cnpjSeguradora,
          numeroApolice: el.napol,
          listaMDFeSeguroAverbacao: _dataAverbacao,
        });
      });

      setListaSeguroCarga(_dataSeguroCarga);
    };

    const setarRodoviario = (data) => {
      setRntrc(data.rodoviario.rntrc);
      setIdVeiculo(data.rodoviario.veiculo ? data.rodoviario.veiculo.id : '');
      setPlacaVeiculo(data.rodoviario.veiculo ? data.rodoviario.veiculo.placa : null);

      let itemCiot = 0;
      const _dataCiot = [];
      data.rodoviario.listaMDFeCiot.forEach(el => {
        itemCiot = itemCiot + 1;
        _dataCiot.push({
          item: itemCiot,
          codigo: el.codigo,
          cnpj: el.cnpj,
          cpf: el.cpf,
        });
      });
      setListaCiot(_dataCiot);

      let itemValePedagio = 0;
      const _dataValePedagio = [];
      data.rodoviario.listaMDFeValePedagio.forEach(el => {
        itemValePedagio = itemValePedagio + 1;
        _dataValePedagio.push({
          item: itemValePedagio,
          valePedagioCnpjForn: el.valePedagioCnpjForn,
          valePedagioCnpjPg: el.valePedagioCnpjPg,
          valePedagioNCompra: el.valePedagioNCompra,
          valePedagioValor: el.valePedagioValor,
        });
      });
      setListaValePedagio(_dataValePedagio);

      let itemInfPag = 0;
      const _dataInfPag = [];
      data.rodoviario.listaMDFeInfPag.forEach(el => {
        itemInfPag = itemInfPag + 1;

        // puxar lista de componentes
        let itemInfPagComp = 0;
        const _dataInfPagComp = [];
        el.listaMDFeInfPagComp.forEach(elComp => {
          itemInfPagComp = itemInfPagComp + 1;
          _dataInfPagComp.push({
            item: itemInfPagComp,
            tpComp: elComp.tpComp,
            vComp: elComp.vcomp,
            xComp: elComp.xcomp.trim(),
          });
        });

        // puxar lista de infPrazo
        let itemInfPagInfPrazo = 0;
        const _dataInfPagInfPrazo = [];
        el.listaMDFeInfPagInfPrazo.forEach(elInfPrazo => {
          itemInfPagInfPrazo = itemInfPagInfPrazo + 1;
          const _dVenc = formataDataMoment(converteData(elInfPrazo.dvenc), '/');
          _dataInfPagInfPrazo.push({
            item: itemInfPagInfPrazo,
            dVenc: _dVenc,
            vParcela: elInfPrazo.vparcela,
            nParcela: elInfPrazo.nparcela,
          });
        });

        _dataInfPag.push({
          item: itemInfPag,
          xNome: el.xnome,
          cpfCnpjResponsavel: el.cpfCnpjResponsavel,
          idEstrangeiro: el.idEstrangeiro,
          vContrato: el.vcontrato,
          indAltoDesemp: el.indAltoDesemp,
          indPag: el.indPag,
          vAdiant: el.vadiant,
          indAntecipaAdiant: el.indAntecipaAdiant,
          tpAntecip: el.tpAntecip,
          codBanco: el.codBanco,
          codAgencia: el.codAgencia,
          cnpjIpfe: el.cnpjIpfe,
          pix: el.pix,
          listaMDFeInfPagComp: _dataInfPagComp,
          listaMDFeInfPagInfPrazo: _dataInfPagInfPrazo,
        });
      });
      setListaInfPag(_dataInfPag);

      let itemContratante = 0;
      const _dataContratante = [];
      data.rodoviario.listaMDFeContratante.forEach(el => {
        itemContratante = itemContratante + 1;
        _dataContratante.push({
          item: itemContratante,
          cnpj: el.cnpj,
          cpf: el.cpf,
        });
      });
      setListaContratante(_dataContratante);

      let itemReboque = 0;
      const _dataReboque = [];
      data.rodoviario.listaMDFeReboque.forEach(el => {
        itemReboque = itemReboque + 1;
        _dataReboque.push({
          item: itemReboque,
          id: el.veiculo.id,
          placaReboque: el.veiculo.placa,
        });
      });
      setListaReboque(_dataReboque);
    };

    const setarListaAutXml = (data) => {
      let itemAutXml = 0;
      const _dataAutXml = [];

      data.listaMDFeAutXML.forEach(el => {
        itemAutXml = itemAutXml + 1;
        _dataAutXml.push({
          item: itemAutXml,
          cnpj: el.cnpj,
          cpf: el.cpf,
        });
      });

      setListaAutXml(_dataAutXml);
    };

    const setarListaDocFiscal = (data) => {
      let itemDoc = 0;
      const _dataDoc = [];

      data.listaMDFeDoc.forEach(el => {
        itemDoc = itemDoc + 1;

        let itemUnidTransporte = 0;
        const _dataUnidTransporte = [];
        if (el.listaMDFeDocUnidTransporte.length > 0) {
          el.listaMDFeDocUnidTransporte.forEach(elTransp => {
            itemUnidTransporte = itemUnidTransporte + 1;

            let itemUnidTransporteLacre = 0;
            const _dataUnidTransporteLacre = [];
            if (elTransp.listaMDFeDocUnidTransporteLacre.length > 0) {
              elTransp.listaMDFeDocUnidTransporteLacre.forEach(elLacre => {
                itemUnidTransporteLacre = itemUnidTransporteLacre + 1;
                _dataUnidTransporteLacre.push({
                  item: itemUnidTransporteLacre,
                  numero: elLacre.numero,
                });
              });
            }

            let itemUnidTransporteInfCarga = 0;
            const _dataUnidTransporteInfCarga = [];
            if (elTransp.listaMDFeDocUnidTransporteInfCarga.length > 0) {
              elTransp.listaMDFeDocUnidTransporteInfCarga.forEach(elInfCarga => {
                itemUnidTransporteInfCarga = itemUnidTransporteInfCarga + 1;
                _dataUnidTransporteInfCarga.push({
                  item: itemUnidTransporteInfCarga,
                  cargaTpUnid: elInfCarga.cargaTpUnid,
                  cargaIdUnid: elInfCarga.cargaIdUnid,
                });
              });
            }

            _dataUnidTransporte.push({
              item: itemUnidTransporte,
              transpTpUnid: elTransp.transpTpUnid,
              transpIdUnid: elTransp.transpIdUnid,
              listaMDFeDocUnidTransporteLacreDTO: _dataUnidTransporteLacre,
              listaMDFeDocUnidTransporteInfCargaDTO: _dataUnidTransporteInfCarga,
            });
          });
        }

        let itemProdutoPerigoso = 0;
        const _dataProdutoPerigoso = [];
        if (el.listaMDFeDocProdutoPerigoso.length > 0) {
          el.listaMDFeDocProdutoPerigoso.forEach(elProdutoPerigoso => {
            itemProdutoPerigoso = itemProdutoPerigoso + 1;
            _dataProdutoPerigoso.push({
              item: itemProdutoPerigoso,
              nOnu: elProdutoPerigoso.nonu,
              xNomeAe: elProdutoPerigoso.xnomeAe,
              qtdProd: elProdutoPerigoso.qtdProd,
              qVolTipo: elProdutoPerigoso.qvolTipo,
              xClaRisco: elProdutoPerigoso.xclaRisco,
              grEmb: elProdutoPerigoso.grEmb,
            });
          });
        }

        _dataDoc.push({
          item: itemDoc,
          mod: el.mod,
          chaveAcesso: el.chaveAcesso,
          segCodBarra: el.segCodBarra,
          reentrega: el.reentrega ? el.reentrega : false,
          listaMDFeDocUnidTransporteDTO: _dataUnidTransporte,
          listaMDFeDocProdutoPerigosoDTO: _dataProdutoPerigoso,
        });
      });

      // console.log('setarListaDocFiscal _dataDoc: ', _dataDoc);

      setListaDocFiscal(_dataDoc);
    };

    const setarListaMunicipioDescarga = (data) => {
      // console.log('data set mun descarregamento: \n', data);
      let itemMunicipioDescarga = 0;
      const _dataMunicipioDescarga = [];
      if (data.listaMDFeMunicipioDescarga.length > 0) {
        data.listaMDFeMunicipioDescarga.forEach(elDescarrega => {
          itemMunicipioDescarga = itemMunicipioDescarga + 1;

          let itemDoc = 0;
          const _dataDoc = [];
          if (elDescarrega.listaMDFeDoc.length > 0) {
            elDescarrega.listaMDFeDoc.forEach(el => {
              itemDoc = itemDoc + 1;
              let itemUnidTransporte = 0;
              const _dataUnidTransporte = [];
              if (el.listaMDFeDocUnidTransporte.length > 0) {
                el.listaMDFeDocUnidTransporte.forEach(elTransp => {
                  itemUnidTransporte = itemUnidTransporte + 1;

                  let itemUnidTransporteLacre = 0;
                  const _dataUnidTransporteLacre = [];
                  if (elTransp.listaMDFeDocUnidTransporteLacre.length > 0) {
                    elTransp.listaMDFeDocUnidTransporteLacre.forEach(elLacre => {
                      itemUnidTransporteLacre = itemUnidTransporteLacre + 1;
                      _dataUnidTransporteLacre.push({
                        item: itemUnidTransporteLacre,
                        numero: elLacre.numero,
                      });
                    });
                  }

                  let itemUnidTransporteInfCarga = 0;
                  const _dataUnidTransporteInfCarga = [];
                  if (elTransp.listaMDFeDocUnidTransporteInfCarga.length > 0) {
                    elTransp.listaMDFeDocUnidTransporteInfCarga.forEach(elInfCarga => {
                      let itemUnidCargaLacre = 0;
                      const _dataUnidCargaLacre = [];
                      if (elInfCarga.listaMDFeDocUnidTransporteInfCargaLacre.length > 0) {
                        elInfCarga.listaMDFeDocUnidTransporteInfCargaLacre.forEach(elLacre => {
                          itemUnidCargaLacre = itemUnidCargaLacre + 1;
                          _dataUnidCargaLacre.push({
                            item: itemUnidCargaLacre,
                            numero: elLacre.numero,
                          });
                        });
                      }

                      itemUnidTransporteInfCarga = itemUnidTransporteInfCarga + 1;
                      _dataUnidTransporteInfCarga.push({
                        item: itemUnidTransporteInfCarga,
                        cargaTpUnid: elInfCarga.cargaTpUnid,
                        cargaIdUnid: elInfCarga.cargaIdUnid,
                        listaMDFeDocUnidTransporteInfCargaLacreDTO: _dataUnidCargaLacre,

                      });
                    });
                  }

                  _dataUnidTransporte.push({
                    item: itemUnidTransporte,
                    transpTpUnid: elTransp.transpTpUnid,
                    transpIdUnid: elTransp.transpIdUnid,
                    listaMDFeDocUnidTransporteLacreDTO: _dataUnidTransporteLacre,
                    listaMDFeDocUnidTransporteInfCargaDTO: _dataUnidTransporteInfCarga,
                  });
                });
              }

              let itemProdutoPerigoso = 0;
              const _dataProdutoPerigoso = [];
              if (el.listaMDFeDocProdutoPerigoso.length > 0) {
                el.listaMDFeDocProdutoPerigoso.forEach(elProdutoPerigoso => {
                  itemProdutoPerigoso = itemProdutoPerigoso + 1;
                  _dataProdutoPerigoso.push({
                    item: itemProdutoPerigoso,
                    nOnu: elProdutoPerigoso.nonu,
                    xNomeAe: elProdutoPerigoso.xnomeAe,
                    qtdProd: elProdutoPerigoso.qtdProd,
                    qVolTipo: elProdutoPerigoso.qvolTipo,
                    xClaRisco: elProdutoPerigoso.xclaRisco,
                    grEmb: elProdutoPerigoso.grEmb,
                  });
                });
              }

              _dataDoc.push({
                item: itemDoc,
                mod: el.mod,
                chaveAcesso: el.chaveAcesso,
                segCodBarra: el.segCodBarra,
                reentrega: el.reentrega ? el.reentrega : false,
                listaMDFeDocUnidTransporteDTO: _dataUnidTransporte,
                listaMDFeDocProdutoPerigosoDTO: _dataProdutoPerigoso,
              });
            });
          }

          // console.log('setar mun descarrega no getdata: ', elDescarrega);
          _dataMunicipioDescarga.push({
            item: itemMunicipioDescarga,
            xMunDescarga: elDescarrega.xmunDescarga,
            cMunDescarga: elDescarrega.cmunDescarga,
            listaMDFeDocDTO: _dataDoc,
          });
        });
      }

      // console.log('setar mun descarregamento: \n', _dataMunicipioDescarregamento);

      setListaMunicipioDescarga(_dataMunicipioDescarga);
    };

    async function getData() {
      try {
        let data = null;

        if (id > 0) {
          data = await getDataById();
        }

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        if (data.idUsuario !== idUsuario) {
          navigate('/consultamdfe');
          toast.error('Acesso negado');
        }

        const _dhEmi = converteData(data.dhEmi, true);
        const _dhIniViagem = converteData(data.dhIniViagem, true);

        console.log('getData: ', data);

        setFlag(data.flag);
        setChaveAcesso(data.chaveAcesso);
        setProtocolo(data.protocolo);
        setNumeroRecibo(data.numeroRecibo);
        setNumeroMdf(data.numeroMdf);
        setDhEmi(_dhEmi);
        setTipoEmissao(data.tpEmis);
        setSerie(data.serie);
        setModalidade(data.modal);
        setTipoEmitente(data.tpEmit);
        setTipoTransportador(data.tpTransp);
        setUfInicio(data.ufIni);
        setUfFim(data.ufFim);

        setPlacaVeiculo(data.veiculo ? data.veiculo.placa : null);
        setIdReboque(data.reboque ? data.reboque.id : '');
        setPlacaReboque(data.reboque ? data.reboque.placa : '');

        setDhIniViagem(_dhIniViagem);

        setRntrc(data.rntrc);
        setValePedagioCnpjForn(data.valePedagioCnpjForn);
        setValePedagioCnpjPg(data.valePedagioCnpjPg);
        setValePedagioNCompra(data.valePedagioNCompra);
        setValePedagioValor(data.valePedagioValor);

        setarListaMunicipioDescarga(data);
        setarListaMunicipioCarrega(data);
        setarListaUfPercurso(data);
        setarListaSeguroCarga(data);
        setarListaMDFeLacre(data);
        setarListaAutXml(data);
        setarRodoviario(data);

        setIdParticipante(data.participante.id);
        setUfParticipante(data.participante.uf);
        setCnpjEmpresa(data.cnpjEmpresa.trim());

        setInfCpl(data.infCpl ? data.infCpl.trim() : '');
        setInfAdFisco(data.infAdFisco);

        setVOutro(data.totalVOutro);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      }
    }

    getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, navigate]);

  async function verificarSeMultiEmpresa(idUsuario) {
    try {
      setIsLoading(true);

      const params = `/usuario/${idUsuario}`;

      const response = await axiosAdmin.get(params);

      const _listaEmpresas = get(response.data, 'listaEmpresas', []);

      const listDropdown = [];

      let cnpjPreenchido = false;
      let _cnpjEmpresaStore = get(store.getState().auth, 'cnpjEmpresa', '');

      if (_cnpjEmpresaStore !== null && _cnpjEmpresaStore !== '') {
        setCnpjEmpresa(_cnpjEmpresaStore);
        cnpjPreenchido = true;
      }

      _listaEmpresas.forEach(element => {
        if (!cnpjPreenchido) {
          setCnpjEmpresa(element.cnpj);
          _cnpjEmpresaStore = element.cnpj;
          cnpjPreenchido = true;
        }

        if (element.cnpj === _cnpjEmpresaStore) {
          setUfEmpresa(element.uf); // para calculo tributos
          setRntrc(element.rntrc);
        }

        const nomeEmpresa = element.nomeFantasia ? element.nomeFantasia : element.razaoSocial;

        listDropdown.push({ label: nomeEmpresa, value: element.cnpj });
      });

      listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

      setListaEmpresas(listDropdown);
    } catch (err) {
      // if (mostrarMensagemErro) {
      //   displayErrors(err, dispatch, navigate, '/', '');
      // }
      // mostrarMensagemErro = false;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    async function getUnidadeFederacao() {
      const listDropdown = [];
      try {
        setIsLoading(true);

        const { data: _ufs } = await axiosAdmin.get('/unidadefederacao/');

        _ufs.forEach(element => {
          listDropdown.push({ label: element.sigla, value: element.sigla });
        });
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    getUnidadeFederacao();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function limparCamposAutXml() {
    setAutXmlCnpj('');
    setAutXmlCpf('');
  }

  function limparCamposCiot() {
    setCiotCodigo('');
    setCiotCnpj('');
  }

  function limparCamposDocFiscalCarga() {
    setDocFiscalUnidadeCargaTipo('CONTAINER');
    setDocFiscalUnidadeCargaIdentificacao('');
    setDocFiscalUnidadeCargaNLacres('');
  }

  function limparCamposDocFiscal() {
    setDocFiscalModelo('55');
    setDocFiscalChaveAcesso('');
    setDocFiscalUfDescarrega('MG');
    setDocFiscalUnidadeCargaTipo('CONTAINER');
    setDocFiscalUnidadeCargaIdentificacao('');
    setDocFiscalUnidadeCargaNLacres('');
    setListaDocFiscalTransporte([]);
    setListaDocFiscalProdutosPerigosos([]);
    setListaLacreUnidTransporte([]);
    setListaMDFeLacre([]);
  }

  function limparCamposDocFiscalProdutosPerigosos() {
    setDocFiscalProdutoPerigosoOnu('');
    setDocFiscalProdutoPerigosoClasse('');
    setDocFiscalProdutoPerigosoNomeEmbarque('');
    setDocFiscalProdutoPerigosoGrupoEmbalagem('');
    setDocFiscalProdutoPerigosoQtdePorProduto('');
    setDocFiscalProdutoPerigosoQtdeETipoVolume('');
  }

  function limparCamposValePedagio() {
    setValePedagioCnpjForn('');
    setValePedagioCnpjPg('');
    setValePedagioNCompra('');
    setValePedagioValor('');
  }

  function limparCamposInfPag() {
    setInfPagXNome('');
    setInfPagCpfCnpjResponsavel('');
    setInfPagIdEstrangeiro('');
    setInfPagVContrato(0);
    setInfPagIndAltoDesemp(false);
    setInfPagIndPag('AVISTA');
    setInfPagVAdiant(0);
    setInfPagIndAntecipaAdiant(false);
    setInfPagTpAntecip(null);
    setInfPagCodBanco('');
    setInfPagCodAgencia('');
    setInfPagCnpjIpfe('');
    setInfPagPix('');
  }

  function limparCamposInfPagComponente() {
    setInfPagTpComp('');
    setInfPagVComp(0);
    setInfPagXComp('');
  }

  function limparCamposInfPagInfPrazo() {
    setInfPagInfPrazoDVenc(null);
    setInfPagInfPrazoNParcela(1);
    setInfPagInfPrazoVParcela(0);
  }

  function limparCamposContratante() {
    setContratanteCnpj('');
    setContratanteCpf('');
  }

  function limparCamposReboque() {
    setIdReboque('');
    setPlacaReboque('');
  }

  const onHideCadastroAutXml = () => {
    limparCamposAutXml();
    setShowCadastroAutXml(false);
  };

  const onHideCadastroCiot = () => {
    limparCamposCiot();
    setShowCadastroCiot(false);
  };

  const onHideCadastroDocFiscalTransporte = () => {
    setShowCadastroDocFiscalTransporte(false);
  };

  const onHideCadastroDocFiscalProdutosPerigosos = () => {
    setShowCadastroDocFiscalProdutosPerigosos(false);
  };

  const onHideCadastroDocFiscalCarga = () => {
    limparCamposDocFiscalCarga();
    setShowCadastroDocFiscalCarga(false);
  };

  const onHideCadastroDocFiscal = () => {
    limparCamposDocFiscal();
    setShowCadastroDocFiscal(false);
  };

  const onHideCadastroValePedagio = () => {
    limparCamposValePedagio();
    setShowCadastroValePedagio(false);
  };

  const onHideCadastroInfPag = () => {
    limparCamposInfPag();
    setShowCadastroInfPag(false);
  };

  const onHideCadastroInfPagComponente = () => {
    limparCamposInfPagComponente();
    setShowCadastroInfPagComponente(false);
  };

  const onHideCadastroInfPagInfPrazo = () => {
    limparCamposInfPagInfPrazo();
    setShowCadastroInfPagInfPrazo(false);
  };

  const onHideCadastroContratante = () => {
    limparCamposContratante();
    setShowCadastroContratante(false);
  };

  const onHideCadastroReboque = () => {
    limparCamposReboque();
    setShowCadastroReboque(false);
  };

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);
      const cnpjEmpresa = get(payloadCadastro, 'cnpjEmpresa', '');

      let _dhEmi = null;
      if (dhEmi) {
        _dhEmi = formataDataMoment(dhEmi, '-', true);
      }

      let _dhIniViagem = null;
      if (dhIniViagem) {
        _dhIniViagem = formataDataMoment(dhIniViagem, '-', true);
      }

      let itemMunicipioCarrega = 0;
      const _dataMunicipioCarrega = [];
      if (listaMunicipioCarrega !== undefined) {
        listaMunicipioCarrega.forEach(elementMunicipioCarrega => {
          itemMunicipioCarrega = itemMunicipioCarrega + 1;
          const municipioCarrega = {
            item: itemMunicipioCarrega,
            cMunCarrega: elementMunicipioCarrega.cMunCarrega,
            xMunCarrega: elementMunicipioCarrega.xMunCarrega,
          };

          _dataMunicipioCarrega.push(municipioCarrega);
        });
      }

      let itemUfPercurso = 0;
      const _dataUfPercurso = [];
      if (listaUfPercurso !== undefined) {
        listaUfPercurso.forEach(el => {
          itemUfPercurso = itemUfPercurso + 1;
          const ufPercurso = {
            item: itemUfPercurso,
            uf: el.ufPercurso,
          };

          _dataUfPercurso.push(ufPercurso);
        });
      }

      /* let itemLacreUnidTransporte = 0;
      const _dataLacreUnidTransporte = [];
      if (listaLacreUnidTransporte !== undefined) {
        listaLacreUnidTransporte.forEach(el => {
          itemLacreUnidTransporte = itemLacreUnidTransporte + 1;
          const itemInfCarga = {
            item: itemLacreUnidTransporte,
            numero: el.numeroLacre,
          };

          _dataLacreUnidTransporte.push(itemInfCarga);
        });
      } */

      let itemMDFeLacre = 0;
      const _dataMDFeLacre = [];
      if (listaMDFeLacre !== undefined) {
        listaMDFeLacre.forEach(el => {
          itemMDFeLacre = itemMDFeLacre + 1;
          const itemLacre = {
            item: itemMDFeLacre,
            numero: el.numero,
          };

          _dataMDFeLacre.push(itemLacre);
        });
      }

      let itemInfCargaUnidTransporte = 0;
      const _dataInfCargaUnidTransporte = [];
      if (listaInfCargaUnidTransporte !== undefined) {
        listaInfCargaUnidTransporte.forEach(el => {
          itemInfCargaUnidTransporte = itemInfCargaUnidTransporte + 1;
          const itemInfCarga = {
            item: itemInfCargaUnidTransporte,
            cargaTpUnid: el.tpInfCargaUnidTransporte,
            cargaIdUnid: el.idInfCargaUnidTransporte,
          };

          _dataInfCargaUnidTransporte.push(itemInfCarga);
        });
      }

      let itemSeguroCarga = 0;
      const _dataSeguroCarga = [];
      if (listaSeguroCarga !== undefined) {
        listaSeguroCarga.forEach(el => {
          let itemAverbacao = 0;
          const _dataAverbacao = [];
          if (listaAverbacao !== undefined) {
            listaAverbacao.forEach(el => {
              itemAverbacao = itemAverbacao + 1;
              const averbacao = {
                item: itemAverbacao,
                numero: el.numeroAverbacao,
              };
              _dataAverbacao.push(averbacao);
            });
          }

          itemSeguroCarga = itemSeguroCarga + 1;
          const seguroCarga = {
            item: itemSeguroCarga,
            responsavel: el.responsavel,
            cnpjResponsavel: el.cnpjResponsavel,
            nomeSeguradora: el.nomeSeguradora,
            cnpjSeguradora: el.cnpjSeguradora,
            nApol: el.numeroApolice,
            listaMDFeAverbacaoDTO: _dataAverbacao,
          };

          _dataSeguroCarga.push(seguroCarga);
        });
      }

      let itemAutXml = 0;
      const _dataAutXml = [];
      if (listaAutXml !== undefined) {
        listaAutXml.forEach(el => {
          itemAutXml = itemAutXml + 1;
          const autXml = {
            item: itemAutXml,
            cnpj: el.cnpj,
            cpf: el.cpf,
          };

          _dataAutXml.push(autXml);
        });
      }

      let itemCiot = 0;
      const _dataCiot = [];
      if (listaCiot !== undefined) {
        listaCiot.forEach(el => {
          itemCiot = itemCiot + 1;
          const ciot = {
            item: itemCiot,
            codigo: el.codigo,
            cnpj: el.cnpj,
            cpf: el.cpf,
          };

          _dataCiot.push(ciot);
        });
      }

      // console.log('listaMunicipioDescarga: ', listaMunicipioDescarga);
      let itemMunicipioDescarga = 0;
      const _dataMunicipioDescarga = [];
      if (listaMunicipioDescarga !== undefined) {
        listaMunicipioDescarga.forEach(elementMunicipioDescarga => {
          itemMunicipioDescarga = itemMunicipioDescarga + 1;
          // console.log('elementMunicipioDescarga: ', elementMunicipioDescarga);
          const municipioDescarga = {
            item: itemMunicipioDescarga,
            cMunDescarga: elementMunicipioDescarga.cMunDescarga,
            xMunDescarga: elementMunicipioDescarga.xMunDescarga,
            listaMDFeDocDTO: elementMunicipioDescarga.listaDocFiscalDTO,
          };

          _dataMunicipioDescarga.push(municipioDescarga);
        });
      }

      let itemDocFiscalTransporte = 0;
      const _dataDocFiscalTransporte = [];
      if (listaDocFiscalTransporte !== undefined) {
        listaDocFiscalTransporte.forEach(el => {
          itemDocFiscalTransporte = itemDocFiscalTransporte + 1;
          const docFiscalTransporte = {
            item: itemDocFiscalTransporte,
          };

          _dataDocFiscalTransporte.push(docFiscalTransporte);
        });
      }

      let itemContratante = 0;
      const _dataContratante = [];
      if (listaContratante !== undefined) {
        listaContratante.forEach(el => {
          itemContratante = itemContratante + 1;
          const contratante = {
            item: itemContratante,
            cnpj: el.cnpj,
            cpf: el.cpf,
          };

          _dataContratante.push(contratante);
        });
      }

      let itemReboque = 0;
      const _dataReboque = [];
      if (listaReboque !== undefined) {
        listaReboque.forEach(el => {
          itemReboque = itemReboque + 1;
          const reboque = {
            item: itemReboque,
            idReboque: el.id,
          };

          _dataReboque.push(reboque);
        });
      }

      let itemValePedagio = 0;
      const _dataValePedagio = [];
      if (listaValePedagio !== undefined) {
        listaValePedagio.forEach(el => {
          itemValePedagio = itemValePedagio + 1;
          const valePedagio = {
            item: itemValePedagio,
            valePedagioCnpjForn: el.valePedagioCnpjForn,
            valePedagioCnpjPg: el.valePedagioCnpjPg,
            valePedagioNCompra: el.valePedagioNCompra,
            valePedagioValor: el.valePedagioValor,
          };

          _dataValePedagio.push(valePedagio);
        });
      }

      let itemInfPagComp = 0;
      const _dataInfPagComp = [];
      if (listaInfPagComponente !== undefined) {
        listaInfPagComponente.forEach(el => {
          itemInfPagComp = itemInfPagComp + 1;
          const _infPagComp = {
            item: itemInfPagComp,
            tpComp: el.tpComp,
            vComp: el.vComp,
            xComp: el.xComp,
          };

          _dataInfPagComp.push(_infPagComp);
        });
      }

      let itemInfPagInfPrazo = 0;
      const _dataInfPagInfPrazo = [];
      if (listaInfPagInfPrazo !== undefined) {
        listaInfPagInfPrazo.forEach(el => {
          itemInfPagInfPrazo = itemInfPagInfPrazo + 1;
          const _infPagInfPrazo = {
            item: itemInfPagInfPrazo,
            dVenc: el.dVenc,
            nParcela: el.nParcela,
            vParcela: el.vParcela,
          };

          _dataInfPagInfPrazo.push(_infPagInfPrazo);
        });
      }

      let itemInfPag = 0;
      const _dataInfPag = [];
      if (listaInfPag !== undefined) {
        listaInfPag.forEach(el => {
          itemInfPag = itemInfPag + 1;
          const infPag = {
            item: itemInfPag,
            xNome: el.xNome,
            cpfCnpjResponsavel: el.cpfCnpjResponsavel,
            idEstrangeiro: el.idEstrangeiro,
            vContrato: el.vContrato,
            indAltoDesemp: el.indAltoDesemp,
            indPag: el.indPag,
            vAdiant: el.vAdiant,
            indAntecipaAdiant: el.indAntecipaAdiant,
            tpAntecip: el.tpAntecip,
            codBanco: el.codBanco,
            codAgencia: el.codAgencia,
            cnpjIpfe: el.cnpjIpfe,
            pix: el.pix,
            listaMDFeInfPagCompDTO: _dataInfPagComp,
            listaMDFeInfPagInfPrazoDTO: _dataInfPagInfPrazo,
          };

          _dataInfPag.push(infPag);
        });
      }

      const _dataRodoviario = {
        rntrc,
        idVeiculo,
        listaMDFeCiotDTO: _dataCiot,
        listaMDFeValePedagioDTO: _dataValePedagio,
        listaMDFeInfPagDTO: _dataInfPag,
        listaMDFeContratanteDTO: _dataContratante,
        listaMDFeReboqueDTO: _dataReboque,
      };

      let informacaoComplementar = '';

      informacaoComplementar = informacaoComplementar + ' ' + infCpl;

      const shippingData = {
        flag,
        chaveAcesso,
        protocolo,
        numeroRecibo,
        idDest,
        idUsuario,
        cnpjEmpresa,
        idParticipante,
        cMdf: Math.random().toString().slice(2, 10),
        numeroMdf,
        dhEmi: _dhEmi,
        tpEmit: tipoEmitente,
        tpTransp: tipoTransportador,
        tpEmis: tipoEmissao,
        mod,
        serie,
        modal: modalidade,
        ufIni: ufInicio,
        ufFim,
        dhIniViagem: _dhIniViagem,
        valePedagioCnpjForn,
        valePedagioCnpjPg,
        infCpl: informacaoComplementar ? informacaoComplementar.trim() : '',
        infAdFisco,
        rodoviario: _dataRodoviario,

        listaMDFeMunicipioCarregaDTO: _dataMunicipioCarrega,
        listaMDFeMunicipioDescargaDTO: _dataMunicipioDescarga,
        listaMDFeUfPercursoDTO: _dataUfPercurso,
        listaMDFeSeguroDTO: _dataSeguroCarga,
        listaMDFeLacreDTO: _dataMDFeLacre,
        listaMDFeAutXMLDTO: _dataAutXml,
      };

      console.log('Shipping data: ', shippingData);

      let payloadDataTableList = {};

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/mdfe/${id}`, shippingData), 'data', {});
        payloadDataTableList.id = id;
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/mdfe', shippingData), 'data', {});
      }

      toast.success('MDF-e salva com sucesso');
      childToParentConsulta(payloadDataTableList, id);
    } catch (err) {
      // console.log('err:', err);
      displayErrors(err, dispatch, navigate, '', 'Erro ao salvar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    setShowConfirmCancelarDigitacaoMdfe(true);
  };

  // eslint-disable-next-line consistent-return
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (serie === '' || serie === null) {
      toast.info('Série deve ser informada');
      return false;
    }

    if (numeroMdf === '' || numeroMdf <= 0 || numeroMdf === null) {
      toast.info('Número do MDF-e inválido');
      return false;
    }

    if (dhEmi === null || dhEmi === '') {
      toast.info('Data Emissão inválida');
      return false;
    }

    if (listaMunicipioCarrega.length <= 0) {
      toast.info('Nenhum município de carregamento informado.');
      return false;
    }

    if (listaMunicipioDescarga.length <= 0) {
      toast.info('Nenhum município de Descarregamento informado.');
      return false;
    }

    if (placaVeiculo === null) {
      toast.info('Nenhum veículo informado para modal Rodoviário.');
      return false;
    }

    salvarRegistro();
  };

  const onHideConsultaParticipante = () => {
    setShowConsultaParticipante(false);
  };

  const childToParent = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (empresaCnpj === e.cnpjEmpresa.trim()) {
        setIdParticipante(idElement);

        if (e.razaoSocial) {
          //
        }
        if (e.uf) {
          setUfParticipante(e.uf);
          ufEmpresa === e.uf ? setIdDest('INTERNA') : setIdDest('INTERESTADUAL');
        }

        setShowConsultaParticipante(false);
      } else {
        toast.warning('Participante selecionado não pertence a empresa emitente da NF-e');
      }
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const cancelDeleteAutXml = () => {
    setShowConfirmDeleteAutXml(false);
  };

  const cancelDeleteCiot = () => {
    setShowConfirmDeleteCiot(false);
  };

  const cancelDeleteDocFiscalTransporte = () => {
    setShowConfirmDeleteDocFiscalTransporte(false);
  };

  const cancelDeleteDocFiscalProdutosPerigosos = () => {
    setShowConfirmDeleteDocFiscalProdutosPerigosos(false);
  };

  const cancelDeleteDocFiscalCarga = () => {
    setShowConfirmDeleteDocFiscalCarga(false);
  };

  const cancelDeleteDocFiscal = () => {
    setShowConfirmDeleteDocFiscal(false);
  };

  const cancelDeleteValePedagio = () => {
    setShowConfirmDeleteValePedagio(false);
  };

  const cancelDeleteInfPag = () => {
    setShowConfirmDeleteInfPag(false);
  };

  const cancelDeleteInfPagComponente = () => {
    setShowConfirmDeleteInfPagComponente(false);
  };

  const cancelDeleteInfPagInfPrazo = () => {
    setShowConfirmDeleteInfPagInfPrazo(false);
  };

  const cancelDeleteContratante = () => {
    setShowConfirmDeleteContratante(false);
  };

  const cancelDeleteReboque = () => {
    setShowConfirmDeleteReboque(false);
  };

  const cancelEdicaoEnviada = () => {
    childToParentConsulta();
  };

  const cancelCancelarDigitacaoMdfe = () => {
    setShowConfirmCancelarDigitacaoMdfe(false);
  };

  const confirmEdicaoEnviada = () => {
    setShowConfirmEdicaoEnviada(false);
  };

  const confirmDeleteAutXml = () => {
    const item = get(selectedAutXml, 'item', 0);

    if (item > 0) {
      const _listaAutXml = listaAutXml;

      const index = _listaAutXml.indexOf(_listaAutXml.find(element => element.item === item));

      if (index >= 0) {
        _listaAutXml.splice(index, 1);

        _listaAutXml.forEach(element => {
          if (element.item > item) {
            const _index = _listaAutXml.indexOf(element);

            _listaAutXml[_index].item = _listaAutXml[_index].item - 1;
          }
        });

        setListaAutXml(_listaAutXml);

        setShowConfirmDeleteAutXml(false);
      }
    }
  };

  const confirmDeleteCiot = () => {
    const item = get(selectedCiot, 'item', 0);

    if (item > 0) {
      const _listaCiot = listaCiot;

      const index = _listaCiot.indexOf(_listaCiot.find(element => element.item === item));

      if (index >= 0) {
        _listaCiot.splice(index, 1);

        _listaCiot.forEach(element => {
          if (element.item > item) {
            const _index = _listaCiot.indexOf(element);

            _listaCiot[_index].item = _listaCiot[_index].item - 1;
          }
        });

        setListaCiot(_listaCiot);

        setShowConfirmDeleteCiot(false);
      }
    }
  };

  const confirmDeleteDocFiscalTransporte = () => {
    const item = get(selectedDocFiscalTransporte, 'item', 0);

    if (item > 0) {
      const _listaDocFiscalTransporte = listaDocFiscalTransporte;

      const index = _listaDocFiscalTransporte.indexOf(_listaDocFiscalTransporte.find(element => element.item === item));

      if (index >= 0) {
        _listaDocFiscalTransporte.splice(index, 1);

        _listaDocFiscalTransporte.forEach(element => {
          if (element.item > item) {
            const _index = _listaDocFiscalTransporte.indexOf(element);

            _listaDocFiscalTransporte[_index].item = _listaDocFiscalTransporte[_index].item - 1;
          }
        });

        setListaDocFiscalTransporte(_listaDocFiscalTransporte);

        setShowConfirmDeleteDocFiscalTransporte(false);
      }
    }
  };

  const confirmDeleteDocFiscalProdutosPerigosos = () => {
    const item = get(selectedDocFiscalProdutosPerigosos, 'item', 0);

    if (item > 0) {
      const _listaDocFiscalProdutosPerigosos = listaDocFiscalProdutosPerigosos;

      const index = _listaDocFiscalProdutosPerigosos.indexOf(_listaDocFiscalProdutosPerigosos.find(element => element.item === item));

      if (index >= 0) {
        _listaDocFiscalProdutosPerigosos.splice(index, 1);

        _listaDocFiscalProdutosPerigosos.forEach(element => {
          if (element.item > item) {
            const _index = _listaDocFiscalProdutosPerigosos.indexOf(element);

            _listaDocFiscalProdutosPerigosos[_index].item = _listaDocFiscalProdutosPerigosos[_index].item - 1;
          }
        });

        setListaDocFiscalProdutosPerigosos(_listaDocFiscalProdutosPerigosos);

        setShowConfirmDeleteDocFiscalProdutosPerigosos(false);
      }
    }
  };

  const confirmDeleteDocFiscalCarga = () => {
    const item = get(selectedDocFiscalCarga, 'item', 0);

    if (item > 0) {
      const _listaDocFiscalCarga = listaDocFiscalCarga;

      const index = _listaDocFiscalCarga.indexOf(_listaDocFiscalCarga.find(element => element.item === item));

      if (index >= 0) {
        _listaDocFiscalCarga.splice(index, 1);

        _listaDocFiscalCarga.forEach(element => {
          if (element.item > item) {
            const _index = _listaDocFiscalCarga.indexOf(element);

            _listaDocFiscalCarga[_index].item = _listaDocFiscalCarga[_index].item - 1;
          }
        });

        setListaDocFiscalCarga(_listaDocFiscalCarga);

        setShowConfirmDeleteDocFiscalCarga(false);
      }
    }
  };

  const confirmDeleteDocFiscal = () => {
    const item = get(selectedDocFiscal, 'item', 0);

    if (item > 0) {
      const _listaDocFiscal = listaDocFiscal;

      const index = _listaDocFiscal.indexOf(_listaDocFiscal.find(element => element.item === item));

      if (index >= 0) {
        _listaDocFiscal.splice(index, 1);

        _listaDocFiscal.forEach(element => {
          if (element.item > item) {
            const _index = _listaDocFiscal.indexOf(element);

            _listaDocFiscal[_index].item = _listaDocFiscal[_index].item - 1;
          }
        });

        setListaDocFiscal(_listaDocFiscal);

        setShowConfirmDeleteDocFiscal(false);
      }
    }
  };

  const confirmDeleteValePedagio = () => {
    const item = get(selectedValePedagio, 'item', 0);

    if (item > 0) {
      const _listaValePedagio = listaValePedagio;

      const index = _listaValePedagio.indexOf(_listaValePedagio.find(element => element.item === item));

      if (index >= 0) {
        _listaValePedagio.splice(index, 1);

        _listaValePedagio.forEach(element => {
          if (element.item > item) {
            const _index = _listaValePedagio.indexOf(element);

            _listaValePedagio[_index].item = _listaValePedagio[_index].item - 1;
          }
        });

        setListaValePedagio(_listaValePedagio);

        setShowConfirmDeleteValePedagio(false);
      }
    }
  };

  const confirmDeleteInfPag = () => {
    const item = get(selectedInfPag, 'item', 0);

    if (item > 0) {
      const _listaInfPag = listaInfPag;

      const index = _listaInfPag.indexOf(_listaInfPag.find(element => element.item === item));

      if (index >= 0) {
        _listaInfPag.splice(index, 1);

        _listaInfPag.forEach(element => {
          if (element.item > item) {
            const _index = _listaInfPag.indexOf(element);

            _listaInfPag[_index].item = _listaInfPag[_index].item - 1;
          }
        });

        setListaInfPag(_listaInfPag);

        setShowConfirmDeleteInfPag(false);
      }
    }
  };

  const confirmDeleteInfPagComponente = () => {
    const item = get(selectedInfPagComponente, 'item', 0);

    if (item > 0) {
      const _listaInfPagComponente = listaInfPagComponente;

      const index = _listaInfPagComponente.indexOf(_listaInfPagComponente.find(element => element.item === item));

      if (index >= 0) {
        _listaInfPagComponente.splice(index, 1);

        _listaInfPagComponente.forEach(element => {
          if (element.item > item) {
            const _index = _listaInfPagComponente.indexOf(element);

            _listaInfPagComponente[_index].item = _listaInfPagComponente[_index].item - 1;
          }
        });

        setListaInfPagComponente(_listaInfPagComponente);

        setShowConfirmDeleteInfPagComponente(false);
      }
    }
  };

  const confirmDeleteInfPagInfPrazo = () => {
    const item = get(selectedInfPagInfPrazo, 'item', 0);

    if (item > 0) {
      const _listaInfPagInfPrazo = listaInfPagInfPrazo;

      const index = _listaInfPagInfPrazo.indexOf(_listaInfPagInfPrazo.find(element => element.item === item));

      if (index >= 0) {
        _listaInfPagInfPrazo.splice(index, 1);

        _listaInfPagInfPrazo.forEach(element => {
          if (element.item > item) {
            const _index = _listaInfPagInfPrazo.indexOf(element);

            _listaInfPagInfPrazo[_index].item = _listaInfPagInfPrazo[_index].item - 1;
          }
        });

        setListaInfPagInfPrazo(_listaInfPagInfPrazo);

        setShowConfirmDeleteInfPagInfPrazo(false);
      }
    }
  };

  const confirmDeleteContratante = () => {
    const item = get(selectedContratante, 'item', 0);

    if (item > 0) {
      const _listaContratante = listaContratante;

      const index = _listaContratante.indexOf(_listaContratante.find(element => element.item === item));

      if (index >= 0) {
        _listaContratante.splice(index, 1);

        _listaContratante.forEach(element => {
          if (element.item > item) {
            const _index = _listaContratante.indexOf(element);

            _listaContratante[_index].item = _listaContratante[_index].item - 1;
          }
        });

        setListaContratante(_listaContratante);

        setShowConfirmDeleteContratante(false);
      }
    }
  };

  const confirmDeleteReboque = () => {
    const item = get(selectedReboque, 'item', 0);

    if (item > 0) {
      const _listaReboque = listaReboque;

      const index = _listaReboque.indexOf(_listaReboque.find(element => element.item === item));

      if (index >= 0) {
        _listaReboque.splice(index, 1);

        _listaReboque.forEach(element => {
          if (element.item > item) {
            const _index = _listaReboque.indexOf(element);

            _listaReboque[_index].item = _listaReboque[_index].item - 1;
          }
        });

        setListaReboque(_listaReboque);

        setShowConfirmDeleteReboque(false);
      }
    }
  };

  const confirmCancelarDigitacaoMdfe = () => {
    childToParentConsulta();
  };

  const handleDeleteAutXml = (e) => {
    e.preventDefault();

    const item = get(selectedAutXml, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaAutXml.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteAutXml(true);
    } else {
      toast.warning('Por favor, selecione o CNPJ/CPF autorizado para exclusão');
    }
  };

  const handleDeleteCiot = (e) => {
    e.preventDefault();

    const item = get(selectedCiot, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaCiot.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteCiot(true);
    } else {
      toast.warning('Por favor, selecione o CIOT para exclusão');
    }
  };

  const handleDeleteDocFiscalTransporte = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscalTransporte, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscalTransporte.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteDocFiscalTransporte(true);
    } else {
      toast.warning('Por favor, selecione o Transporte para exclusão');
    }
  };

  const handleDeleteDocFiscalProdutosPerigosos = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscalProdutosPerigosos, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscalProdutosPerigosos.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteDocFiscalProdutosPerigosos(true);
    } else {
      toast.warning('Por favor, selecione o Produto Perigoso para exclusão');
    }
  };

  const handleDeleteDocFiscalCarga = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscalCarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscalCarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteDocFiscalCarga(true);
    } else {
      toast.warning('Por favor, selecione a Carga para exclusão');
    }
  };

  const handleDeleteDocFiscal = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscal, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscal.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteDocFiscal(true);
    } else {
      toast.warning('Por favor, selecione o Doc Fiscal para exclusão');
    }
  };

  const handleDeleteValePedagio = (e) => {
    e.preventDefault();

    const item = get(selectedValePedagio, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaValePedagio.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteValePedagio(true);
    } else {
      toast.warning('Por favor, selecione o Vale Pedágio autorizado para exclusão');
    }
  };

  const handleDeleteInfPag = (e) => {
    e.preventDefault();

    const item = get(selectedInfPag, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfPag.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteInfPag(true);
    } else {
      toast.warning('Por favor, selecione o Pagamento de Frete para exclusão');
    }
  };

  const handleDeleteInfPagComponente = (e) => {
    e.preventDefault();

    const item = get(selectedInfPagComponente, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfPagComponente.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteInfPagComponente(true);
    } else {
      toast.warning('Por favor, selecione o Componente do Pagamento de Frete para exclusão');
    }
  };

  const handleDeleteInfPagInfPrazo = (e) => {
    e.preventDefault();

    const item = get(selectedInfPagInfPrazo, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfPagInfPrazo.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteInfPagInfPrazo(true);
    } else {
      toast.warning('Por favor, selecione a Informação do Pagamento a Prazo para exclusão');
    }
  };

  const handleDeleteContratante = (e) => {
    e.preventDefault();

    const item = get(selectedContratante, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaContratante.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteContratante(true);
    } else {
      toast.warning('Por favor, selecione o Contratante para exclusão');
    }
  };

  const handleDeleteReboque = (e) => {
    e.preventDefault();

    const item = get(selectedReboque, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaReboque.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteReboque(true);
    } else {
      toast.warning('Por favor, selecione o Reboque para exclusão');
    }
  };

  const handleEditAutXml = (e) => {
    e.preventDefault();

    const item = get(selectedAutXml, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaAutXml.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o CNPJ/CPF autorizado para edição');
        return;
      }

      setEditandoAutXml(item);

      limparCamposAutXml();

      setAutXmlCnpj(_itemSelecionado.cnpj);
      setAutXmlCpf(_itemSelecionado.cpf);

      setShowCadastroAutXml(true);
    }
  };

  const handleEditCiot = (e) => {
    e.preventDefault();

    const item = get(selectedCiot, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaCiot.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o CNPJ/CPF autorizado para edição');
        return;
      }

      setEditandoCiot(item);

      limparCamposCiot();

      setCiotCodigo(_itemSelecionado.codigo);
      setCiotCnpj(_itemSelecionado.cnpj);

      setShowCadastroCiot(true);
    }
  };

  const handleEditDocFiscalTransporte = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscalTransporte, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscalTransporte.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o Transporte para edição');
        return;
      }

      setEditandoDocFiscalTransporte(item);

      // console.log('_item selecionado transporte inclusao: ', _itemSelecionado);
      setTranspTpUnid(_itemSelecionado.transpTpUnid);
      setTranspIdUnid(_itemSelecionado.transpIdUnid);

      setListaLacreUnidTransporte(_itemSelecionado.listaMDFeDocUnidTransporteLacreDTO);

      // console.log('_itemSelecionado inf carga: ', _itemSelecionado.listaMDFeDocUnidTransporteInfCargaDTO);
      setListaInfCargaUnidTransporte(_itemSelecionado.listaMDFeDocUnidTransporteInfCargaDTO);
      setShowCadastroDocFiscalTransporte(true);
    }
  };

  const handleEditDocFiscalProdutosPerigosos = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscalProdutosPerigosos, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscalProdutosPerigosos.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o Produto Perigoso para edição');
        return;
      }

      setEditandoDocFiscalProdutosPerigosos(item);

      // console.log('_item selecionado produto perigoso inclusao: \n', _itemSelecionado);
      setDocFiscalProdutoPerigosoOnu(_itemSelecionado.nOnu);
      setDocFiscalProdutoPerigosoNomeEmbarque(_itemSelecionado.xNomeAe);
      setDocFiscalProdutoPerigosoClasse(_itemSelecionado.xClaRisco);
      setDocFiscalProdutoPerigosoGrupoEmbalagem(_itemSelecionado.grEmb);
      setDocFiscalProdutoPerigosoQtdeETipoVolume(_itemSelecionado.qVolTipo);
      setDocFiscalProdutoPerigosoQtdePorProduto(_itemSelecionado.qtdProd);

      setShowCadastroDocFiscalProdutosPerigosos(true);
    }
  };

  const handleEditDocFiscalCarga = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscalCarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscalCarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione a Carga para edição');
        return;
      }

      setEditandoDocFiscalCarga(item);

      limparCamposDocFiscalCarga();

      setDocFiscalUnidadeCargaTipo(_itemSelecionado.tipo);
      setDocFiscalUnidadeCargaIdentificacao(_itemSelecionado.identificacao);
      setDocFiscalUnidadeCargaNLacres(_itemSelecionado.nLacres);

      setShowCadastroDocFiscalCarga(true);
    }
  };

  const handleEditDocFiscal = (e) => {
    e.preventDefault();

    const item = get(selectedDocFiscal, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDocFiscal.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o Doc Fiscal para edição');
        return;
      }

      setEditandoDocFiscal(item);

      limparCamposDocFiscal();

      // console.log('_itemSelecionado edit doc fiscal: ', _itemSelecionado);

      setDocFiscalModelo(_itemSelecionado.mod);
      setDocFiscalChaveAcesso(_itemSelecionado.chaveAcesso);
      setDocFiscalReentrega(_itemSelecionado.reentrega);
      setDocFiscalSegundoCodigoBarras(_itemSelecionado.segCodBarra);
      setDocFiscalMunDescarrega(_itemSelecionado.docFiscalXMunDescarrega);
      setDocFiscalReentrega(_itemSelecionado.reentrega ? _itemSelecionado.reentrega : false);
      setListaDocFiscalTransporte(_itemSelecionado.listaMDFeDocUnidTransporteDTO);
      setListaDocFiscalProdutosPerigosos(_itemSelecionado.listaMDFeDocProdutoPerigosoDTO);

      setShowCadastroDocFiscal(true);
    }
  };

  const handleEditValePedagio = (e) => {
    e.preventDefault();

    const item = get(selectedValePedagio, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaValePedagio.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o vale pedágio para edição');
        return;
      }

      setEditandoValePedagio(item);

      limparCamposValePedagio();

      setValePedagioCnpjForn(_itemSelecionado.valePedagioCnpjForn);
      setValePedagioCnpjPg(_itemSelecionado.valePedagioCnpjPg);
      setValePedagioNCompra(_itemSelecionado.valePedagioNCompra);
      setValePedagioValor(_itemSelecionado.valePedagioValor);

      setShowCadastroValePedagio(true);
    }
  };

  const handleEditInfPag = (e) => {
    e.preventDefault();

    const item = get(selectedInfPag, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfPag.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o pagamento de frete para edição');
        return;
      }

      setEditandoInfPag(item);

      limparCamposInfPag();

      setInfPagXNome(_itemSelecionado.xNome);
      setInfPagCpfCnpjResponsavel(_itemSelecionado.cpfCnpjResponsavel);
      setInfPagIdEstrangeiro(_itemSelecionado.idEstrangeiro);
      setInfPagVContrato(_itemSelecionado.vContrato);
      setInfPagIndAltoDesemp(_itemSelecionado.indAltoDesemp);
      setInfPagIndPag(_itemSelecionado.indPag);
      setInfPagVAdiant(_itemSelecionado.vAdiant);
      setInfPagIndAntecipaAdiant(_itemSelecionado.indAntecipaAdiant);
      setInfPagTpAntecip(_itemSelecionado.tpAntecip);
      setInfPagCodBanco(_itemSelecionado.codBanco);
      setInfPagCodAgencia(_itemSelecionado.codAgencia);
      setInfPagCnpjIpfe(_itemSelecionado.cnpjIpfe);
      setInfPagPix(_itemSelecionado.pix);

      setListaInfPagComponente(_itemSelecionado.listaMDFeInfPagComp);
      setListaInfPagInfPrazo(_itemSelecionado.listaMDFeInfPagInfPrazo);

      setShowCadastroInfPag(true);
    }
  };

  const handleEditInfPagComponente = (e) => {
    e.preventDefault();

    const item = get(selectedInfPagComponente, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfPagComponente.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o componente do pagamento de frete para edição');
        return;
      }

      setEditandoInfPagComponente(item);

      limparCamposInfPagComponente();

      setInfPagTpComp(_itemSelecionado.tpComp);
      setInfPagVComp(_itemSelecionado.vComp);
      setInfPagXComp(_itemSelecionado.xComp);

      setShowCadastroInfPagComponente(true);
    }
  };

  const handleEditInfPagInfPrazo = (e) => {
    e.preventDefault();

    const item = get(selectedInfPagInfPrazo, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfPagInfPrazo.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione a Informação do Pagamento a Prazo para edição');
        return;
      }

      setEditandoInfPagInfPrazo(item);

      limparCamposInfPagInfPrazo();

      setInfPagInfPrazoDVenc(moment(_itemSelecionado.dVenc, 'DD-MM-YYYY').toDate());
      setInfPagInfPrazoVParcela(_itemSelecionado.vParcela);
      setInfPagInfPrazoNParcela(_itemSelecionado.nParcela);

      setShowCadastroInfPagInfPrazo(true);
    }
  };

  const handleEditContratante = (e) => {
    e.preventDefault();

    const item = get(selectedContratante, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaContratante.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o Contratante para edição');
        return;
      }

      setEditandoContratante(item);

      limparCamposContratante();

      setContratanteCnpj(_itemSelecionado.cnpj);
      setContratanteCpf(_itemSelecionado.cpf);

      setShowCadastroContratante(true);
    }
  };

  const handleEditReboque = (e) => {
    e.preventDefault();

    const item = get(selectedReboque, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaReboque.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o Reboque para edição');
        return;
      }

      setEditandoReboque(item);

      limparCamposReboque();

      setIdReboque(_itemSelecionado.id);
      setPlacaReboque(_itemSelecionado.placaReboque);

      setShowCadastroReboque(true);
    }
  };

  const handleOkAutXml = () => {
    if (autXmlCnpj === '' || autXmlCpf === '') {
      toast.warning('CNPJ ou CPF deve ser informado');
      return;
    }

    const _listaAutXml = listaAutXml;

    let item = 0;
    listaAutXml.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoAutXml && editandoAutXml > 0) {
      item = editandoAutXml;

      const index = _listaAutXml.indexOf(_listaAutXml.find(element => element.item === editandoAutXml));

      if (index >= 0) {
        _listaAutXml.splice(index, 1);
      }
    }

    _listaAutXml.push({
      item,
      cnpj: autXmlCnpj,
      cpf: autXmlCpf,
    });

    limparCamposAutXml();
    setShowCadastroAutXml(false);
  };

  const handleOkCiot = () => {
    if (ciotCodigo === '') {
      toast.warning('Código deve ser informado');
      return;
    }

    if (ciotCnpj === '') {
      toast.warning('CNPJ/CPF deve ser informado');
      return;
    }

    const _listaCiot = listaCiot;

    let item = 0;
    listaCiot.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoCiot && editandoCiot > 0) {
      item = editandoCiot;

      const index = _listaCiot.indexOf(_listaCiot.find(element => element.item === editandoCiot));

      if (index >= 0) {
        _listaCiot.splice(index, 1);
      }
    }

    _listaCiot.push({
      item,
      codigo: ciotCodigo,
      cnpj: ciotCnpj,
    });

    limparCamposCiot();
    setShowCadastroCiot(false);
  };

  const handleOkDocFiscalTransporte = () => {
    const _listaDocFiscalTransporte = listaDocFiscalTransporte;

    let item = 0;
    listaDocFiscalTransporte.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });

    // console.log('listaDocFiscalTransporte: ', listaDocFiscalTransporte);

    item = item + 1;

    if (editandoDocFiscalTransporte && editandoDocFiscalTransporte > 0) {
      item = editandoDocFiscalTransporte;

      const index = _listaDocFiscalTransporte.indexOf(_listaDocFiscalTransporte.find(element => element.item === editandoDocFiscalTransporte));

      if (index >= 0) {
        _listaDocFiscalTransporte.splice(index, 1);
      }
    }

    _listaDocFiscalTransporte.push({
      item,
      transpTpUnid,
      transpIdUnid,
      listaMDFeDocUnidTransporteLacreDTO: listaLacreUnidTransporte,
      listaMDFeDocUnidTransporteInfCargaDTO: listaInfCargaUnidTransporte,
    });

    console.log('ok inclusa doc fiscal transp: ', _listaDocFiscalTransporte);

    setShowCadastroDocFiscalTransporte(false);
  };

  const handleOkDocFiscalProdutosPerigosos = () => {
    // console.log('listaDocFiscalProdutosPerigosos: ', listaDocFiscalProdutosPerigosos);
    const _listaDocFiscalProdutosPerigosos = listaDocFiscalProdutosPerigosos;

    let item = 0;
    listaDocFiscalProdutosPerigosos.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });

    item = item + 1;

    if (editandoDocFiscalProdutosPerigosos && editandoDocFiscalProdutosPerigosos > 0) {
      item = editandoDocFiscalProdutosPerigosos;

      const index = _listaDocFiscalProdutosPerigosos.indexOf(_listaDocFiscalProdutosPerigosos.find(element => element.item === editandoDocFiscalProdutosPerigosos));

      if (index >= 0) {
        _listaDocFiscalProdutosPerigosos.splice(index, 1);
      }
    }

    _listaDocFiscalProdutosPerigosos.push({
      item,
      nOnu: docFiscalProdutoPerigosoOnu,
      xNomeAe: docFiscalProdutoPerigosoNomeEmbarque,
      xClaRisco: docFiscalProdutoPerigosoClasse,
      grEmb: docFiscalProdutoPerigosoGrupoEmbalagem,
      qtdProd: docFiscalProdutoPerigosoQtdePorProduto,
      qVolTipo: docFiscalProdutoPerigosoQtdeETipoVolume,
    });

    setShowCadastroDocFiscalProdutosPerigosos(false);
  };

  const handleOkDocFiscalCarga = () => {
    const _listaDocFiscalCarga = listaDocFiscalCarga;

    let item = 0;
    listaDocFiscalCarga.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoDocFiscalCarga && editandoDocFiscalCarga > 0) {
      item = editandoDocFiscalCarga;

      const index = _listaDocFiscalCarga.indexOf(_listaDocFiscalCarga.find(element => element.item === editandoDocFiscalCarga));

      if (index >= 0) {
        _listaDocFiscalCarga.splice(index, 1);
      }
    }

    _listaDocFiscalCarga.push({
      item,
    });

    limparCamposDocFiscalCarga();
    setShowCadastroDocFiscalCarga(false);
  };

  const handleOkDocFiscal = () => {
    if (docFiscalChaveAcesso.length < 44) {
      toast.warning('Chave de Acesso deve ser informada');
      return;
    }

    const _listaDocFiscal = listaDocFiscal;

    let item = 0;
    listaDocFiscal.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoDocFiscal && editandoDocFiscal > 0) {
      item = editandoDocFiscal;

      const index = _listaDocFiscal.indexOf(_listaDocFiscal.find(element => element.item === editandoDocFiscal));

      if (index >= 0) {
        _listaDocFiscal.splice(index, 1);
      }
    }

    // console.log('listadocfiscal muni descar: ', listaMunicipioDescarga);

    _listaDocFiscal.push({
      item,
      mod: docFiscalModelo,
      chaveAcesso: docFiscalChaveAcesso,
      segCodBarra: docFiscalSegundoCodigoBarras,
      listaMDFeDocUnidTransporteDTO: listaDocFiscalTransporte,
      listaMDFeDocProdutoPerigosoDTO: listaDocFiscalProdutosPerigosos,
      reentrega: docFiscalReentrega,
    });

    console.log('_listaDocFiscal ok doc fiscal: ', _listaDocFiscal);

    setListaDocFiscal(_listaDocFiscal);

    limparCamposDocFiscal();
    setShowCadastroDocFiscal(false);
  };

  const handleOkValePedagio = () => {
    if (valePedagioCnpjForn === '' || valePedagioCnpjForn.length < 14) {
      toast.warning('CNPJ fornecedor deve ser informado');
      return;
    }
    if (valePedagioCnpjPg === '') {
      toast.warning('CNPJ/CPF pagador deve ser informado');
      return;
    }
    if (valePedagioCnpjPg.length !== 14 && valePedagioCnpjPg.length !== 11) {
      toast.warning('CNPJ/CPF pagador incorreto');
      return;
    }
    if (valePedagioValor <= 0) {
      toast.warning('Valor deve ser informado');
      return;
    }

    const _listaValePedagio = listaValePedagio;

    let item = 0;
    listaValePedagio.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoValePedagio && editandoValePedagio > 0) {
      item = editandoValePedagio;

      const index = _listaValePedagio.indexOf(_listaValePedagio.find(element => element.item === editandoValePedagio));

      if (index >= 0) {
        _listaValePedagio.splice(index, 1);
      }
    }

    _listaValePedagio.push({
      item,
      valePedagioCnpjForn,
      valePedagioCnpjPg,
      valePedagioNCompra,
      valePedagioValor,
    });

    limparCamposValePedagio();
    setShowCadastroValePedagio(false);
  };

  const handleOkInfPag = () => {
    if (infPagXNome === '') {
      toast.warning('Nome do Responsável deve ser informado');
      return;
    }
    if (infPagCpfCnpjResponsavel === '') {
      toast.warning('CNPJ/CPF Responsável deve ser informado');
      return;
    }
    if (infPagCpfCnpjResponsavel.trim().length !== 14 && infPagCpfCnpjResponsavel.trim().length !== 11) {
      toast.warning('CNPJ/CPF responsável incorreto..........');
      return;
    }
    if (infPagVContrato <= 0) {
      toast.warning('Valor do Contrato deve ser informado');
      return;
    }

    const _listaInfPag = listaInfPag;

    let item = 0;
    listaInfPag.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoInfPag && editandoInfPag > 0) {
      item = editandoInfPag;

      const index = _listaInfPag.indexOf(_listaInfPag.find(element => element.item === editandoInfPag));

      if (index >= 0) {
        _listaInfPag.splice(index, 1);
      }
    }

    _listaInfPag.push({
      item,
      xNome: infPagXNome,
      cpfCnpjResponsavel: infPagCpfCnpjResponsavel,
      idEstrangeiro: infPagIdEstrangeiro,
      vContrato: infPagVContrato,
      indAltoDesemp: infPagIndAltoDesemp,
      indPag: infPagIndPag,
      vAdiant: infPagVAdiant,
      indAntecipaAdiant: infPagIndAntecipaAdiant,
      tpAntecip: infPagTpAntecip,
      codBanco: infPagCodBanco,
      codAgencia: infPagCodAgencia,
      cnpjIpfe: infPagCnpjIpfe,
      pix: infPagPix,
      listaMDFeInfPagCompDTO: listaInfPagComponente,
      listaMDFeInfPagInfPrazoDTO: listaInfPagInfPrazo,
    });

    console.log('lista inf pag: ', _listaInfPag);

    limparCamposInfPag();
    setShowCadastroInfPag(false);
  };

  const handleOkInfPagComponente = () => {
    if (infPagTpComp === null) {
      toast.warning('Tipo componente deve ser informado');
      return;
    }
    if (infPagVComp <= 0) {
      toast.warning('Valor do Contrato deve ser informado');
      return;
    }
    if (infPagXComp === '') {
      toast.warning('Descrição do componente deve ser informado');
      return;
    }

    const _listaInfPagComponente = listaInfPagComponente;

    let item = 0;
    listaInfPagComponente.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoInfPagComponente && editandoInfPagComponente > 0) {
      item = editandoInfPagComponente;

      const index = _listaInfPagComponente.indexOf(_listaInfPagComponente.find(element => element.item === editandoInfPagComponente));

      if (index >= 0) {
        _listaInfPagComponente.splice(index, 1);
      }
    }

    _listaInfPagComponente.push({
      item,
      tpComp: infPagTpComp,
      vComp: infPagVComp,
      xComp: infPagXComp,
    });

    console.log('lista inf pag componente: ', _listaInfPagComponente);

    limparCamposInfPagComponente();
    setShowCadastroInfPagComponente(false);
  };

  const handleOkInfPagInfPrazo = () => {
    if (infPagInfPrazoDVenc === null) {
      toast.warning('Data do Vencimento deve ser informada');
      return;
    }
    if (infPagInfPrazoVParcela <= 0) {
      toast.warning('Valor da parcela deve ser informada');
      return;
    }
    if (infPagInfPrazoNParcela === '') {
      toast.warning('Número da parcela deve ser informado');
      return;
    }

    const _listaInfPagInfPrazo = listaInfPagInfPrazo;

    let item = 0;
    listaInfPagInfPrazo.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoInfPagInfPrazo && editandoInfPagInfPrazo > 0) {
      item = editandoInfPagInfPrazo;

      const index = _listaInfPagInfPrazo.indexOf(_listaInfPagInfPrazo.find(element => element.item === editandoInfPagInfPrazo));

      if (index >= 0) {
        _listaInfPagInfPrazo.splice(index, 1);
      }
    }

    _listaInfPagInfPrazo.push({
      item,
      dVenc: formataDataMoment(infPagInfPrazoDVenc, '-', true),
      nParcela: infPagInfPrazoNParcela,
      vParcela: infPagInfPrazoVParcela,
    });

    console.log('lista inf pag infPrazo: ', _listaInfPagInfPrazo);

    limparCamposInfPagInfPrazo();
    setShowCadastroInfPagInfPrazo(false);
  };

  const handleOkContratante = () => {
    if (contratanteCnpj === '' && contratanteCpf === '') {
      toast.warning('CNPJ e CPF devem ser informado');
      return;
    }
    if (contratanteCnpj === '') {
      toast.warning('CNPJ deve ser informado');
      return;
    }
    if (contratanteCpf === '') {
      toast.warning('CPF deve ser informado');
      return;
    }

    const _listaContratante = listaContratante;

    let item = 0;
    listaContratante.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoContratante && editandoContratante > 0) {
      item = editandoContratante;

      const index = _listaContratante.indexOf(_listaContratante.find(element => element.item === editandoContratante));

      if (index >= 0) {
        _listaContratante.splice(index, 1);
      }
    }

    _listaContratante.push({
      item,
      cnpj: contratanteCnpj,
      cpf: contratanteCpf,
    });

    limparCamposContratante();
    setShowCadastroContratante(false);
  };

  const handleOkReboque = () => {
    if (idReboque <= 0 && placaReboque === '') {
      toast.warning('Placa Reboque deve ser informado');
      return;
    }

    const _listaReboque = listaReboque;

    let item = 0;
    listaReboque.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoReboque && editandoReboque > 0) {
      item = editandoReboque;

      const index = _listaReboque.indexOf(_listaReboque.find(element => element.item === editandoReboque));

      if (index >= 0) {
        _listaReboque.splice(index, 1);
      }
    }

    _listaReboque.push({
      item,
      id: idReboque,
      placaReboque,
    });

    limparCamposReboque();
    setShowCadastroReboque(false);
  };

  const confirmDialogFooterTotaisNota = (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <button
            onClick={handleSubmit}
            type="button"
            className="btn btn-success"
          >
            <i className="pi pi-check"></i>
            Salvar NF-e
          </button>
          <button
            // onClick={cancelTotaisNota}
            type="button"
            className="btn btn-danger"
          >
            <i className="pi pi-times"></i>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );

  const confirmDialogFooterAutXml = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteAutXml} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteAutXml} />
    </div>
  );

  const confirmDialogFooterCiot = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteCiot} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteCiot} />
    </div>
  );

  const confirmDialogFooterDocFiscalTransporte = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteDocFiscalTransporte} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteDocFiscalTransporte} />
    </div>
  );

  const confirmDialogFooterDocFiscalProdutosPerigosos = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteDocFiscalProdutosPerigosos} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteDocFiscalProdutosPerigosos} />
    </div>
  );

  const confirmDialogFooterDocFiscalCarga = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteDocFiscalCarga} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteDocFiscalCarga} />
    </div>
  );

  const confirmDialogFooterDocFiscal = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteDocFiscal} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteDocFiscal} />
    </div>
  );

  const confirmDialogFooterValePedagio = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteValePedagio} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteValePedagio} />
    </div>
  );

  const confirmDialogFooterInfPag = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteInfPag} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteInfPag} />
    </div>
  );

  const confirmDialogFooterInfPagComponente = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteInfPagComponente} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteInfPagComponente} />
    </div>
  );

  const confirmDialogFooterInfPagInfPrazo = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteInfPagInfPrazo} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteInfPagInfPrazo} />
    </div>
  );

  const confirmDialogFooterContratante = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteContratante} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteContratante} />
    </div>
  );

  const confirmDialogFooterReboque = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteReboque} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteReboque} />
    </div>
  );

  const confirmDialogFooterEdicaoEnviada = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmEdicaoEnviada} />
      <Button label="Não" icon="pi pi-times" onClick={cancelEdicaoEnviada} />
    </div>
  );

  const confirmDialogFooterCancelarDigitacaoMdfe = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmCancelarDigitacaoMdfe} />
      <Button label="Não" icon="pi pi-times" onClick={cancelCancelarDigitacaoMdfe} />
    </div>
  );

  const childToParentVeiculo = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.id) {
        setIdVeiculo(e.id);
      }
      if (e.placa) {
        setPlacaVeiculo(e.placa);
      }
      setShowConsultaVeiculo(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const onHideConsultaVeiculo = () => {
    setShowConsultaVeiculo(false);
  };

  const limparVeiculo = () => {
    setIdVeiculo('');
    setPlacaVeiculo('');
  };

  const onHideConsultaMunicipio = () => {
    setShowConsultaMunicipio(false);
  };

  const childToParentReboque = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.id) {
        setIdReboque(e.id);
      }
      if (e.placa) {
        setPlacaReboque(e.placa);
      }
      setShowConsultaReboque(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const onHideConsultaReboque = () => {
    setShowConsultaReboque(false);
  };

  const limparReboque = () => {
    setIdReboque('');
    setPlacaReboque('');
  };

  const childToParentMunicipio = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.codigo) {
        setCMunCarrega(e.codigo);
      }
      if (e.descricao) {
        setXMuncarrega(e.descricao);
      }
      setShowConsultaMunicipio(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const childToParentMunicipioDescarga = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.codigo) {
        setCMunDescarga(e.codigo);
      }
      if (e.descricao) {
        setXMunDescarga(e.descricao);
      }
      setShowConsultaMunicipioDescarga(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  function limparCamposUfPercurso() {
    setUfPercurso('');
  }

  function limparCamposAverbacao() {
    setNumeroAverbacao('');
  }

  function limparCamposLacreUnidTransporte() {
    setNumeroLacreUnidTransporte('');
  }

  function limparCamposLacre() {
    setNumeroMDFeLacre('');
  }

  function limparCamposMDFeLacre() {
    setNumeroMDFeLacre('');
  }

  function limparCamposLacreUnidCarga() {
    setNumeroLacreUnidCarga('');
  }

  function limparCamposInfCargaUnidTransporte() {
    setTpInfCargaUnidTransporte('');
    setIdInfCargaUnidTransporte('');
    setListaLacreUnidCarga([]);
  }

  function limparCamposSeguroCarga() {
    setSeguroResponsavel('EMITENTE');
    setSeguroCnpjResponsavel('');
    setSeguroNomeSeguradora('');
    setSeguroCnpjSeguradora('');
    setSeguroNumeroApolice('');
  }

  const cancelDeleteUfPercurso = () => {
    setShowConfirmDeleteUfPercurso(false);
  };

  const cancelDeleteAverbacao = () => {
    setShowConfirmDeleteAverbacao(false);
  };

  const cancelDeleteLacre = () => {
    setShowConfirmDeleteLacre(false);
  };

  const cancelDeleteLacreUnidTransporte = () => {
    setShowConfirmDeleteLacreUnidTransporte(false);
  };

  const cancelDeleteMDFeLacre = () => {
    setShowConfirmDeleteMDFeLacre(false);
  };

  const cancelDeleteLacreUnidCarga = () => {
    setShowConfirmDeleteLacreUnidCarga(false);
  };

  const cancelDeleteInfCargaUnidTransporte = () => {
    setShowConfirmDeleteInfCargaUnidTransporte(false);
  };

  const cancelDeleteSeguroCarga = () => {
    setShowConfirmDeleteSeguroCarga(false);
  };

  const confirmDeleteUfPercurso = () => {
    const item = get(selectedUfPercurso, 'item', 0);

    if (item > 0) {
      const _listaUfPercurso = listaUfPercurso;

      const index = _listaUfPercurso.indexOf(_listaUfPercurso.find(element => element.item === item));

      if (index >= 0) {
        _listaUfPercurso.splice(index, 1);

        _listaUfPercurso.forEach(element => {
          if (element.item > item) {
            const _index = _listaUfPercurso.indexOf(element);

            _listaUfPercurso[_index].item = _listaUfPercurso[_index].item - 1;
          }
        });

        setListaUfPercurso(_listaUfPercurso);

        setShowConfirmDeleteUfPercurso(false);
      }
    }
  };

  const confirmDeleteAverbacao = () => {
    const item = get(selectedAverbacao, 'item', 0);

    if (item > 0) {
      const _listaAverbacao = listaAverbacao;

      const index = _listaAverbacao.indexOf(_listaAverbacao.find(element => element.item === item));

      if (index >= 0) {
        _listaAverbacao.splice(index, 1);

        _listaAverbacao.forEach(element => {
          if (element.item > item) {
            const _index = _listaAverbacao.indexOf(element);

            _listaAverbacao[_index].item = _listaAverbacao[_index].item - 1;
          }
        });

        setListaAverbacao(_listaAverbacao);

        setShowConfirmDeleteAverbacao(false);
      }
    }
  };

  const confirmDeleteLacreUnidTransporte = () => {
    const item = get(selectedLacreUnidTransporte, 'item', 0);

    if (item > 0) {
      const _listaLacre = listaLacreUnidTransporte;

      const index = _listaLacre.indexOf(_listaLacre.find(element => element.item === item));

      if (index >= 0) {
        _listaLacre.splice(index, 1);

        _listaLacre.forEach(element => {
          if (element.item > item) {
            const _index = _listaLacre.indexOf(element);

            _listaLacre[_index].item = _listaLacre[_index].item - 1;
          }
        });

        setListaLacreUnidTransporte(_listaLacre);

        setShowConfirmDeleteLacreUnidTransporte(false);
      }
    }
  };

  const confirmDeleteMDFeLacre = () => {
    const item = get(selectedMDFeLacre, 'item', 0);

    if (item > 0) {
      const _listaLacre = listaMDFeLacre;

      const index = _listaLacre.indexOf(_listaLacre.find(element => element.item === item));

      if (index >= 0) {
        _listaLacre.splice(index, 1);

        _listaLacre.forEach(element => {
          if (element.item > item) {
            const _index = _listaLacre.indexOf(element);

            _listaLacre[_index].item = _listaLacre[_index].item - 1;
          }
        });

        setListaMDFeLacre(_listaLacre);

        setShowConfirmDeleteMDFeLacre(false);
      }
    }
  };

  const confirmDeleteLacreUnidCarga = () => {
    const item = get(selectedLacreUnidCarga, 'item', 0);

    if (item > 0) {
      const _listaLacre = listaLacreUnidCarga;

      const index = _listaLacre.indexOf(_listaLacre.find(element => element.item === item));

      if (index >= 0) {
        _listaLacre.splice(index, 1);

        _listaLacre.forEach(element => {
          if (element.item > item) {
            const _index = _listaLacre.indexOf(element);

            _listaLacre[_index].item = _listaLacre[_index].item - 1;
          }
        });

        setListaLacreUnidCarga(_listaLacre);

        setShowConfirmDeleteLacreUnidCarga(false);
      }
    }
  };

  const confirmDeleteInfCargaUnidTransporte = () => {
    const item = get(selectedInfCargaUnidTransporte, 'item', 0);

    if (item > 0) {
      const _listaInf = listaInfCargaUnidTransporte;

      const index = _listaInf.indexOf(_listaInf.find(element => element.item === item));

      if (index >= 0) {
        _listaInf.splice(index, 1);

        _listaInf.forEach(element => {
          if (element.item > item) {
            const _index = _listaInf.indexOf(element);

            _listaInf[_index].item = _listaInf[_index].item - 1;
          }
        });

        setListaInfCargaUnidTransporte(_listaInf);

        setShowConfirmDeleteInfCargaUnidTransporte(false);
      }
    }
  };

  const confirmDeleteSeguroCarga = () => {
    const item = get(selectedSeguroCarga, 'item', 0);

    if (item > 0) {
      const _listaSeguroCarga = listaSeguroCarga;

      const index = _listaSeguroCarga.indexOf(_listaSeguroCarga.find(element => element.item === item));

      if (index >= 0) {
        _listaSeguroCarga.splice(index, 1);

        _listaSeguroCarga.forEach(element => {
          if (element.item > item) {
            const _index = _listaSeguroCarga.indexOf(element);

            _listaSeguroCarga[_index].item = _listaSeguroCarga[_index].item - 1;
          }
        });

        setListaSeguroCarga(_listaSeguroCarga);

        setShowConfirmDeleteSeguroCarga(false);
      }
    }
  };

  const handleDeleteUfPercurso = (e) => {
    e.preventDefault();

    const item = get(selectedUfPercurso, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaUfPercurso.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteUfPercurso(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleDeleteAverbacao = (e) => {
    e.preventDefault();

    const item = get(selectedAverbacao, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaAverbacao.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteAverbacao(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleDeleteLacreUnidTransporte = (e) => {
    e.preventDefault();

    const item = get(selectedLacreUnidTransporte, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaLacreUnidTransporte.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteLacreUnidTransporte(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleDeleteMDFeLacre = (e) => {
    e.preventDefault();

    const item = get(selectedMDFeLacre, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaMDFeLacre.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteMDFeLacre(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleDeleteLacreUnidCarga = (e) => {
    e.preventDefault();

    const item = get(selectedLacreUnidCarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaLacreUnidCarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteLacreUnidCarga(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleDeleteInfCargaUnidTransporte = (e) => {
    e.preventDefault();

    const item = get(selectedInfCargaUnidTransporte, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfCargaUnidTransporte.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteInfCargaUnidTransporte(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleDeleteSeguroCarga = (e) => {
    e.preventDefault();

    const item = get(selectedSeguroCarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaSeguroCarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteSeguroCarga(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleEditUfPercurso = (e) => {
    e.preventDefault();

    const item = get(selectedUfPercurso, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaUfPercurso.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoUfPercurso(item);

      setUfPercurso(_itemSelecionado.uf);

      setShowCadastroUfPercurso(true);
    }
  };

  const handleEditAverbacao = (e) => {
    e.preventDefault();

    const item = get(selectedAverbacao, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaAverbacao.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoAverbacao(item);

      setNumeroAverbacao(_itemSelecionado.numeroAverbacao);

      setShowCadastroAverbacao(true);
    }
  };

  const handleEditLacreUnidTransporte = (e) => {
    e.preventDefault();

    const item = get(selectedLacreUnidTransporte, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaLacreUnidTransporte.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoLacreUnidTransporte(item);

      setNumeroLacreUnidTransporte(_itemSelecionado.numero);

      setShowCadastroLacreUnidTransporte(true);
    }
  };

  const handleEditMDFeLacre = (e) => {
    e.preventDefault();

    const item = get(selectedMDFeLacre, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaMDFeLacre.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoMDFeLacre(item);

      setNumeroMDFeLacre(_itemSelecionado.numero);

      setShowCadastroMDFeLacre(true);
    }
  };

  const handleEditLacreUnidCarga = (e) => {
    e.preventDefault();

    const item = get(selectedLacreUnidCarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaLacreUnidCarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoLacreUnidCarga(item);

      setNumeroLacreUnidCarga(_itemSelecionado.numero);

      setShowCadastroLacreUnidCarga(true);
    }
  };

  const handleEditInfCargaUnidTransporte = (e) => {
    e.preventDefault();

    const item = get(selectedInfCargaUnidTransporte, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaInfCargaUnidTransporte.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoInfCargaUnidTransporte(item);

      console.log('edit inf carga uni transporte: ', _itemSelecionado);

      setTpInfCargaUnidTransporte(_itemSelecionado.cargaTpUnid);
      setIdInfCargaUnidTransporte(_itemSelecionado.cargaIdUnid);

      setListaLacreUnidCarga(_itemSelecionado.listaMDFeDocUnidTransporteInfCargaLacreDTO);

      setShowCadastroInfCargaUnidTransporte(true);
    }
  };

  const handleEditSeguroCarga = (e) => {
    e.preventDefault();

    const item = get(selectedSeguroCarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaSeguroCarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoSeguroCarga(item);

      setSeguroResponsavel(_itemSelecionado.responsavel);
      setSeguroCnpjResponsavel(_itemSelecionado.cnpjResponsavel);
      setSeguroNomeSeguradora(_itemSelecionado.nomeSeguradora);
      setSeguroCnpjSeguradora(_itemSelecionado.cnpjSeguradora);
      setSeguroNumeroApolice(_itemSelecionado.numeroApolice);
      setListaAverbacao(_itemSelecionado.listaMDFeSeguroAverbacao);

      setShowCadastroSeguroCarga(true);
    }
  };

  const handleOkUfPercurso = () => {
    if (ufPercurso === '') {
      toast.warning('UF deve ser informada.');
      return;
    }

    if (ufPercurso.toUpperCase() === ufInicio || ufPercurso === ufFim) {
      toast.warning('UF percurso não deve ser igual a UF inicio ou UF fim informada.');
      return;
    }

    let existeUf = false;
    listaUfPercurso.forEach(el => {
      if (el.ufPercurso === ufPercurso) {
        existeUf = true;
      }
    });

    if (existeUf) {
      toast.warning('UF já informada para percurso.');
      return;
    }

    const _listaUfPercurso = listaUfPercurso;

    let item = 0;
    listaUfPercurso.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoUfPercurso && editandoUfPercurso > 0) {
      item = editandoUfPercurso;

      const index = _listaUfPercurso.indexOf(_listaUfPercurso.find(element => element.item === editandoUfPercurso));

      if (index >= 0) {
        _listaUfPercurso.splice(index, 1);
      }
    }

    _listaUfPercurso.push({
      item,
      ufPercurso: ufPercurso.toUpperCase(),
    });

    setListaUfPercurso(_listaUfPercurso);
    limparCamposUfPercurso();
    setShowCadastroUfPercurso(false);
  };

  const handleOkAverbacao = () => {
    if (numeroAverbacao === '') {
      toast.warning('Número averbação deve ser informada.');
      return;
    }

    let existeAverbacao = false;
    listaAverbacao.forEach(el => {
      if (el.numeroAverbacao === numeroAverbacao) {
        existeAverbacao = true;
      }
    });

    if (existeAverbacao) {
      toast.warning('Número Averbação já informada para o seguro.');
      return;
    }

    const _listaAverbacao = listaAverbacao;

    let item = 0;
    listaAverbacao.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoAverbacao && editandoAverbacao > 0) {
      item = editandoAverbacao;

      const index = _listaAverbacao.indexOf(_listaAverbacao.find(element => element.item === editandoAverbacao));

      if (index >= 0) {
        _listaAverbacao.splice(index, 1);
      }
    }

    _listaAverbacao.push({
      item,
      numeroAverbacao,
    });

    setListaAverbacao(_listaAverbacao);
    limparCamposAverbacao();
    setShowCadastroAverbacao(false);
  };

  const handleOkLacreUnidTransporte = () => {
    if (numeroLacreUnidTransporte === '') {
      toast.warning('Número lacre deve ser informada.');
      return;
    }

    let existeLacre = false;
    listaLacreUnidTransporte.forEach(el => {
      if (el.numero === numeroLacreUnidTransporte) {
        existeLacre = true;
      }
    });

    if (existeLacre) {
      toast.warning('Número Lacre já informado.');
      return;
    }

    const _listaLacre = listaLacreUnidTransporte;

    let item = 0;
    listaLacreUnidTransporte.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoLacreUnidTransporte && editandoLacreUnidTransporte > 0) {
      item = editandoLacreUnidTransporte;

      const index = _listaLacre.indexOf(_listaLacre.find(element => element.item === editandoLacreUnidTransporte));

      if (index >= 0) {
        _listaLacre.splice(index, 1);
      }
    }

    _listaLacre.push({
      item,
      numero: numeroLacreUnidTransporte,
    });

    // console.log('_lista lacre: ', _listaLacre);

    setListaLacreUnidTransporte(_listaLacre);
    limparCamposLacreUnidTransporte();
    setShowCadastroLacreUnidTransporte(false);
  };

  const handleOkMDFeLacre = () => {
    if (numeroMDFeLacre === '') {
      toast.warning('Número lacre deve ser informada.');
      return;
    }

    let existeLacre = false;
    listaMDFeLacre.forEach(el => {
      if (el.numero === numeroMDFeLacre) {
        existeLacre = true;
      }
    });

    if (existeLacre) {
      toast.warning('Número Lacre já informado.');
      return;
    }

    const _listaMDFeLacre = listaMDFeLacre;

    let item = 0;
    listaMDFeLacre.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoMDFeLacre && editandoMDFeLacre > 0) {
      item = editandoMDFeLacre;

      const index = _listaMDFeLacre.indexOf(_listaMDFeLacre.find(element => element.item === editandoMDFeLacre));

      if (index >= 0) {
        _listaMDFeLacre.splice(index, 1);
      }
    }

    _listaMDFeLacre.push({
      item,
      numero: numeroMDFeLacre,
    });

    console.log('_lista mdfe lacre: ', _listaMDFeLacre);

    setListaMDFeLacre(_listaMDFeLacre);
    limparCamposMDFeLacre();
    setShowCadastroMDFeLacre(false);
  };

  const handleOkLacreUnidCarga = () => {
    if (numeroLacreUnidCarga === '') {
      toast.warning('Número lacre deve ser informada.');
      return;
    }

    let existeLacre = false;
    listaLacreUnidCarga.forEach(el => {
      if (el.numero === numeroLacreUnidCarga) {
        existeLacre = true;
      }
    });

    if (existeLacre) {
      toast.warning('Número Lacre já informado.');
      return;
    }

    const _listaLacre = listaLacreUnidCarga;

    let item = 0;
    listaLacreUnidCarga.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoLacreUnidCarga && editandoLacreUnidCarga > 0) {
      item = editandoLacreUnidCarga;

      const index = _listaLacre.indexOf(_listaLacre.find(element => element.item === editandoLacreUnidCarga));

      if (index >= 0) {
        _listaLacre.splice(index, 1);
      }
    }

    _listaLacre.push({
      item,
      numero: numeroLacreUnidCarga,
    });

    // console.log('_lista lacre: ', _listaLacre);

    setListaLacreUnidCarga(_listaLacre);
    limparCamposLacreUnidCarga();
    setShowCadastroLacreUnidCarga(false);
  };

  const handleOkInfCargaUnidTransporte = () => {
    if (tpInfCargaUnidTransporte === null) {
      toast.warning('Tipo Unidade Carga deve ser informada.');
      return;
    }

    let existe = false;
    listaInfCargaUnidTransporte.forEach(el => {
      if (el.idInfCargaUnidTransporte === idInfCargaUnidTransporte) {
        existe = true;
      }
    });

    if (existe) {
      toast.warning('Tipo Unidade Carga já informado.');
      return;
    }

    const _listaInf = listaInfCargaUnidTransporte;

    let item = 0;
    listaInfCargaUnidTransporte.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoInfCargaUnidTransporte && editandoInfCargaUnidTransporte > 0) {
      item = editandoInfCargaUnidTransporte;

      const index = _listaInf.indexOf(_listaInf.find(element => element.item === editandoInfCargaUnidTransporte));

      if (index >= 0) {
        _listaInf.splice(index, 1);
      }
    }

    _listaInf.push({
      item,
      cargaTpUnid: tpInfCargaUnidTransporte,
      cargaIdUnid: idInfCargaUnidTransporte,
      listaMDFeDocUnidTransporteInfCargaLacreDTO: listaLacreUnidCarga,
    });

    console.log('inf carga transp lista inf carga: ', _listaInf);

    setListaInfCargaUnidTransporte(_listaInf);
    limparCamposInfCargaUnidTransporte();
    setShowCadastroInfCargaUnidTransporte(false);
  };

  // eslint-disable-next-line consistent-return
  const handleOkSeguroCarga = () => {
    if (seguroCnpjResponsavel === '' && seguroResponsavel === 'CONTRATANTE') {
      toast.info('Cnpj Responsável deve ser informado.');
      return false;
    }

    if (seguroCnpjSeguradora === '' && seguroResponsavel === 'CONTRATANTE') {
      toast.info('Cnpj Responsável deve ser informado.');
      return false;
    }

    // validacoes de campos

    const _listaSeguroCarga = listaSeguroCarga;

    let item = 0;
    listaSeguroCarga.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoSeguroCarga && editandoSeguroCarga > 0) {
      item = editandoSeguroCarga;

      const index = _listaSeguroCarga.indexOf(_listaSeguroCarga.find(element => element.item === editandoSeguroCarga));

      if (index >= 0) {
        _listaSeguroCarga.splice(index, 1);
      }
    }

    _listaSeguroCarga.push({
      item,
      responsavel: seguroResponsavel,
      cnpjResponsavel: seguroCnpjResponsavel,
      nomeSeguradora: seguroNomeSeguradora,
      cnpjSeguradora: seguroCnpjSeguradora,
      numeroApolice: seguroNumeroApolice,
    });

    setListaSeguroCarga(_listaSeguroCarga);
    limparCamposSeguroCarga();
    setShowCadastroSeguroCarga(false);
  };

  const onHideCadastroUfPercurso = () => {
    limparCamposUfPercurso();
    setShowCadastroUfPercurso(false);
  };

  const onHideCadastroAverbacao = () => {
    limparCamposAverbacao();
    setShowCadastroAverbacao(false);
  };

  const onHideCadastroLacreUnidTransporte = () => {
    limparCamposLacreUnidTransporte();
    setShowCadastroLacreUnidTransporte(false);
  };

  const onHideCadastroLacre = () => {
    limparCamposLacre();
    setShowCadastroLacre(false);
  };

  const onHideCadastroMDFeLacre = () => {
    limparCamposMDFeLacre();
    setShowCadastroMDFeLacre(false);
  };

  const onHideCadastroLacreUnidCarga = () => {
    limparCamposLacreUnidCarga();
    setShowCadastroLacreUnidCarga(false);
  };

  const onHideCadastroInfCargaUnidTransporte = () => {
    limparCamposInfCargaUnidTransporte();
    setShowCadastroInfCargaUnidTransporte(false);
  };

  const onHideCadastroSeguroCarga = () => {
    limparCamposSeguroCarga();
    setShowCadastroSeguroCarga(false);
  };

  const confirmDialogFooterUfPercurso = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteUfPercurso} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteUfPercurso} />
    </div>
  );

  const confirmDialogFooterAverbacao = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteAverbacao} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteAverbacao} />
    </div>
  );

  const confirmDialogFooterLacreUnidTransporte = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteLacreUnidTransporte} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteLacreUnidTransporte} />
    </div>
  );

  const confirmDialogFooterMDFeLacre = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteMDFeLacre} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteMDFeLacre} />
    </div>
  );

  const confirmDialogFooterLacreUnidCarga = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteLacreUnidCarga} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteLacreUnidCarga} />
    </div>
  );

  const confirmDialogFooterInfCargaUnidTransporte = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteInfCargaUnidTransporte} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteInfCargaUnidTransporte} />
    </div>
  );

  const confirmDialogFooterSeguroCarga = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteSeguroCarga} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteSeguroCarga} />
    </div>
  );

  function limparCamposMunicipioCarrega() {
    setCMunCarrega('');
    setXMuncarrega('');
  }

  function limparCamposMunicipioDescarga() {
    setCMunDescarga('');
    setXMunDescarga('');
    setListaDocFiscal([]);
  }

  const cancelDeleteMunicipioCarrega = () => {
    setShowConfirmDeleteMunicipioCarrega(false);
  };

  const cancelDeleteMunicipioDescarga = () => {
    setShowConfirmDeleteMunicipioDescarga(false);
  };

  const confirmDeleteMunicipioCarrega = () => {
    const item = get(selectedMunicipioCarrega, 'item', 0);

    if (item > 0) {
      const _listaMunicipioCarrega = listaMunicipioCarrega;

      const index = _listaMunicipioCarrega.indexOf(_listaMunicipioCarrega.find(element => element.item === item));

      if (index >= 0) {
        _listaMunicipioCarrega.splice(index, 1);

        _listaMunicipioCarrega.forEach(element => {
          if (element.item > item) {
            const _index = _listaMunicipioCarrega.indexOf(element);

            _listaMunicipioCarrega[_index].item = _listaMunicipioCarrega[_index].item - 1;
          }
        });

        setListaMunicipioCarrega(_listaMunicipioCarrega);

        setShowConfirmDeleteMunicipioCarrega(false);
      }
    }
  };

  const confirmDeleteMunicipioDescarga = () => {
    const item = get(selectedMunicipioDescarga, 'item', 0);

    if (item > 0) {
      const _listaMunicipioDescarga = listaMunicipioDescarga;

      const index = _listaMunicipioDescarga.indexOf(_listaMunicipioDescarga.find(element => element.item === item));

      if (index >= 0) {
        _listaMunicipioDescarga.splice(index, 1);

        _listaMunicipioDescarga.forEach(element => {
          if (element.item > item) {
            const _index = _listaMunicipioDescarga.indexOf(element);

            _listaMunicipioDescarga[_index].item = _listaMunicipioDescarga[_index].item - 1;
          }
        });

        setListaMunicipioDescarga(_listaMunicipioDescarga);

        setShowConfirmDeleteMunicipioDescarga(false);
      }
    }
  };

  const handleDeleteMunicipioCarrega = (e) => {
    e.preventDefault();

    const item = get(selectedMunicipioCarrega, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaMunicipioCarrega.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteMunicipioCarrega(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleDeleteMunicipioDescarga = (e) => {
    e.preventDefault();

    const item = get(selectedMunicipioDescarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaMunicipioDescarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para exclusão');
        return;
      }

      setShowConfirmDeleteMunicipioDescarga(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  const handleEditMunicipioCarrega = (e) => {
    e.preventDefault();

    const item = get(selectedMunicipioCarrega, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaMunicipioCarrega.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoMunicipioCarrega(item);

      setCMunCarrega(_itemSelecionado.cMunCarrega);
      setXMuncarrega(_itemSelecionado.xMunCarrega);

      setShowCadastroMunicipioCarrega(true);
    }
  };

  const handleEditMunicipioDescarga = (e) => {
    e.preventDefault();

    const item = get(selectedMunicipioDescarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaMunicipioDescarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o item para edição');
        return;
      }

      setEditandoMunicipioDescarga(item);

      // console.log('item Selecionado: ', _itemSelecionado);

      setCMunDescarga(_itemSelecionado.cMunDescarga);
      setXMunDescarga(_itemSelecionado.xMunDescarga);
      setListaDocFiscal(_itemSelecionado.listaMDFeDocDTO);

      setShowCadastroMunicipioDescarga(true);
    }
  };

  const handleOkMunicipioCarrega = () => {
    if (cMunCarrega === '') {
      toast.warning('Código do Município deve ser informado.');
      return;
    }

    let existeMunicipio = false;
    listaMunicipioCarrega.forEach(el => {
      if (el.xMunCarrega === xMunCarrega) {
        existeMunicipio = true;
      }
    });

    if (existeMunicipio) {
      toast.warning('Município já informado para carregamento.');
      return;
    }

    const _listaMunicipioCarrega = listaMunicipioCarrega;

    let item = 0;
    listaMunicipioCarrega.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoMunicipioCarrega && editandoMunicipioCarrega > 0) {
      item = editandoMunicipioCarrega;

      const index = _listaMunicipioCarrega.indexOf(_listaMunicipioCarrega.find(element => element.item === editandoMunicipioCarrega));

      if (index >= 0) {
        _listaMunicipioCarrega.splice(index, 1);
      }
    }

    _listaMunicipioCarrega.push({
      item,
      cMunCarrega,
      xMunCarrega,
    });

    setListaMunicipioCarrega(_listaMunicipioCarrega);
    limparCamposMunicipioCarrega();
    setShowCadastroMunicipioCarrega(false);
  };

  const handleOkMunicipioDescarga = () => {
    if (cMunDescarga === '') {
      toast.warning('Código do Município deve ser informado.');
      return;
    }

    let existeMunicipio = false;
    listaMunicipioDescarga.forEach(el => {
      if (el.xMunDescarga === xMunDescarga) {
        existeMunicipio = true;
      }
    });

    if (existeMunicipio && editandoMunicipioDescarga <= 0) {
      toast.warning('Município já informado para Descarrega.');
      return;
    }

    const _listaMunicipioDescarga = listaMunicipioDescarga;

    let item = 0;
    listaMunicipioDescarga.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoMunicipioDescarga && editandoMunicipioDescarga > 0) {
      item = editandoMunicipioDescarga;

      const index = _listaMunicipioDescarga.indexOf(_listaMunicipioDescarga.find(element => element.item === editandoMunicipioDescarga));

      if (index >= 0) {
        _listaMunicipioDescarga.splice(index, 1);
      }
    }

    _listaMunicipioDescarga.push({
      item,
      cMunDescarga,
      xMunDescarga,
      listaDocFiscalDTO: listaDocFiscal,
    });

    console.log('listamundescarregamento : ', _listaMunicipioDescarga);

    setListaMunicipioDescarga(_listaMunicipioDescarga);
    limparCamposMunicipioDescarga();
    setShowCadastroMunicipioDescarga(false);
  };

  const onHideCadastroMunicipioCarrega = () => {
    limparCamposMunicipioCarrega();
    setShowCadastroMunicipioCarrega(false);
  };

  const onHideCadastroMunicipioDescarga = () => {
    limparCamposMunicipioDescarga();
    setShowCadastroMunicipioDescarga(false);
  };

  const confirmDialogFooterMunicipioCarrega = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteMunicipioCarrega} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteMunicipioCarrega} />
    </div>
  );

  const confirmDialogFooterMunicipioDescarga = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteMunicipioDescarga} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteMunicipioDescarga} />
    </div>
  );

  const searchMunicipios = (event) => {
    const listDropdown = [];

    listaMunicipios.forEach(element => {
      if (element.value.toLowerCase().startsWith(event.query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setFilteredMunicipios(listDropdown);
  };

  const searchMunicipiosDescarga = (event) => {
    const listDropdown = [];

    listaMunicipios.forEach(element => {
      if (element.value.toLowerCase().startsWith(event.query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setFilteredMunicipiosDescarga(listDropdown);
  };

  const handleChangeMunicipio = (event) => {
    const codigo = get(event.value, 'codigo', '');

    const listDropdown = [];

    listaMunicipios.forEach(element => {
      if (element.codigo !== undefined && element.codigo === codigo) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setCMunCarrega('');
    setXMuncarrega('');

    if (listDropdown.length > 0) {
      setCMunCarrega(get(listDropdown[0], 'codigo', ''));
      setXMuncarrega(get(listDropdown[0], 'label', ''));
    }
  };

  const handleChangeMunicipioDescarga = (event) => {
    const codigo = get(event.value, 'codigo', '');

    const listDropdown = [];

    listaMunicipios.forEach(element => {
      if (element.codigo !== undefined && element.codigo === codigo) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setCMunDescarga('');
    setXMunDescarga('');

    if (listDropdown.length > 0) {
      setCMunDescarga(get(listDropdown[0], 'codigo', ''));
      setXMunDescarga(get(listDropdown[0], 'label', ''));
    }
  };

  const titulo = () => (id ? 'MDF-e - Alteração' : 'MDF-e - Inclusão');

  return (

    <div>
      <Loading isLoading={isLoading} />

      <Dialog
        header="Consulta de Veículo"
        visible={showConsultaVeiculo}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaVeiculo()}
      >
        <ConsultaVeiculo menuMode={false} childToParent={childToParentVeiculo} />
      </Dialog>

      <Dialog
        header="Consulta de Reboque"
        visible={showConsultaReboque}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaReboque()}
      >
        <ConsultaVeiculo menuMode={false} childToParent={childToParentReboque} />
      </Dialog>

      <Dialog
        header="Consulta de Participantes"
        visible={showConsultaParticipante}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaParticipante()}
      >
        <ConsultaParticipante menuMode={false} childToParent={childToParent} empresaCnpj={empresaCnpj} />
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmEdicaoEnviada}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterEdicaoEnviada}
        onHide={() => setShowConfirmEdicaoEnviada(false)}
      >
        <p>
          Nota Fiscal já foi enviada. Alteração limitada a alguns campos!
        </p>
        <p>
          Deseja Continuar?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteMunicipioCarrega}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterMunicipioCarrega}
        onHide={() => setShowConfirmDeleteMunicipioCarrega(false)}
      >
        <p>
          Excluir o Município Carregamento?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteMunicipioDescarga}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterMunicipioDescarga}
        onHide={() => setShowConfirmDeleteMunicipioDescarga(false)}
      >
        <p>
          Excluir o Município Descarregamento?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteUfPercurso}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterUfPercurso}
        onHide={() => setShowConfirmDeleteUfPercurso(false)}
      >
        <p>
          Excluir a UF Percurso?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteAverbacao}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterAverbacao}
        onHide={() => setShowConfirmDeleteAverbacao(false)}
      >
        <p>
          Excluir a averbação?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteMDFeLacre}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterMDFeLacre}
        onHide={() => setShowConfirmDeleteMDFeLacre(false)}
      >
        <p>
          Excluir o lacre?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteLacreUnidTransporte}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterLacreUnidTransporte}
        onHide={() => setShowConfirmDeleteLacreUnidTransporte(false)}
      >
        <p>
          Excluir o lacre?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteMDFeLacre}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterMDFeLacre}
        onHide={() => setShowConfirmDeleteMDFeLacre(false)}
      >
        <p>
          Excluir o lacre?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteLacreUnidCarga}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterLacreUnidCarga}
        onHide={() => setShowConfirmDeleteLacreUnidCarga(false)}
      >
        <p>
          Excluir o lacre?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteInfCargaUnidTransporte}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterInfCargaUnidTransporte}
        onHide={() => setShowConfirmDeleteInfCargaUnidTransporte(false)}
      >
        <p>
          Excluir a informação de carga?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteSeguroCarga}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterSeguroCarga}
        onHide={() => setShowConfirmDeleteSeguroCarga(false)}
      >
        <p>
          Excluir o Seguro Carga?
        </p>
      </Dialog>

      <Dialog
        header="MDF-e - Municípios Carregamento"
        visible={showCadastroMunicipioCarrega}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroMunicipioCarrega()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Município*
              </Input100px>
              <AutoComplete
                value={xMunCarrega}
                maxLength={40}
                suggestions={filteredMunicipios}
                completeMethod={searchMunicipios}
                field="label"
                dropdown
                onChange={e => handleChangeMunicipio(e)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkMunicipioCarrega}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroMunicipioCarrega(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Municípios Descarregamento"
        visible={showCadastroMunicipioDescarga}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroMunicipioDescarga()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Município*
              </Input100px>
              <AutoComplete
                value={xMunDescarga}
                maxLength={40}
                suggestions={filteredMunicipiosDescarga}
                completeMethod={searchMunicipiosDescarga}
                field="label"
                dropdown
                onChange={e => handleChangeMunicipioDescarga(e)}
              />
            </div>
          </div>
        </div>
        <TabView activeIndex={activeTabMunicipioDescargaIndex} scrollable onTabChange={(e) => setActiveTabMunicipioDescargaIndex(e.index)}>
          <TabPanel header="Docs. Fiscais - CTE/NFE">
            <div className="row form-elo">
              <div className="docs-fiscais">
                <DataTable
                  header="CTE/NFE - Inclusão"
                  value={listaDocFiscal}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedDocFiscal}
                  onSelectionChange={e => setSelectedDocFiscal(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupDocFiscal)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão CTE/NFE"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoDocFiscal(0);
                      limparCamposDocFiscal(true);
                      setShowCadastroDocFiscal(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar CTE/NFE"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditDocFiscal(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar CTE/NFE"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteDocFiscal(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
        </TabView>

        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Ok Município Descarregamento"
              className="btn btn-success"
              onClick={handleOkMunicipioDescarga}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroMunicipioDescarga(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - UFs Percurso"
        visible={showCadastroUfPercurso}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroUfPercurso()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                UF
              </Input100px>
              <Dropdown
                options={listaUf}
                value={ufPercurso}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setUfPercurso(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkUfPercurso}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroUfPercurso(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Seguro - Averbação"
        visible={showCadastroAverbacao}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroAverbacao()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número Averbação
              </Input155px>
              <InputText
                maxLength={20}
                value={numeroAverbacao}
                onChange={e => setNumeroAverbacao(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkAverbacao}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroAverbacao(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Lacre Unidade de Tranporte"
        visible={showCadastroLacreUnidTransporte}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroLacreUnidTransporte()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número Lacre
              </Input155px>
              <InputText
                maxLength={20}
                value={numeroLacreUnidTransporte}
                onChange={e => setNumeroLacreUnidTransporte(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkLacreUnidTransporte}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroLacreUnidTransporte(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Lacre MDF-e"
        visible={showCadastroLacre}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroLacre()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número Lacre
              </Input155px>
              <InputText
                maxLength={20}
                value={numeroMDFeLacre}
                onChange={e => setNumeroMDFeLacre(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkMDFeLacre}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroMDFeLacre(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Lacre"
        visible={showCadastroMDFeLacre}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroMDFeLacre()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número Lacre
              </Input155px>
              <InputText
                maxLength={20}
                value={numeroMDFeLacre}
                onChange={e => setNumeroMDFeLacre(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkMDFeLacre}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroMDFeLacre(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Lacre Unidade de Carga"
        visible={showCadastroLacreUnidCarga}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroLacreUnidCarga()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número Lacre
              </Input155px>
              <InputText
                maxLength={20}
                value={numeroLacreUnidCarga}
                onChange={e => setNumeroLacreUnidCarga(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkLacreUnidCarga}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroLacreUnidCarga(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Informação da Unidade de Carga do Tranporte"
        visible={showCadastroInfCargaUnidTransporte}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroInfCargaUnidTransporte()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Tipo Unidade Carga*
              </Input200px>
              <Dropdown
                options={listaMdfeTipoUnidCargaDocFiscal}
                value={tpInfCargaUnidTransporte}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTpInfCargaUnidTransporte(e.target.value)}
              />
            </div>
          </div>
          <div className="col-8">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Identificação*
              </Input155px>
              <InputText
                maxLength={20}
                value={idInfCargaUnidTransporte}
                onChange={e => setIdInfCargaUnidTransporte(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="lacres">
            <DataTable
              header="Lacres Unidade Carga - Inclusão"
              value={listaLacreUnidCarga}
              size="small"
              stripedRows
              responsiveLayout="scroll"
              sortField="item"
              selectionMode="single"
              selection={selectedLacreUnidCarga}
              onSelectionChange={e => setSelectedLacreUnidCarga(e.value)}
              selectableRows
              dataKey="item"
              emptyMessage="Nenhum Item cadastrado"
            >
              {fillColumns(columnsSetupLacreUnidCarga)}
            </DataTable>
          </div>
          <br />
          <div className="row form-elo">
            <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button
                type="button"
                title="Inclusão Lacre Unidade Transporte"
                className="btn btn-success"
                style={{ borderRadius: '15px' }}
                onClick={() => {
                  setEditandoLacreUnidCarga(0);
                  limparCamposLacreUnidCarga(true);
                  setShowCadastroLacreUnidCarga(true);
                }}
              >
                <i className="pi pi-plus"></i>
              </button>
              <button
                type="button"
                title="Alterar Lacre Unidade Carga"
                className="btn btn-warning"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleEditLacreUnidCarga(e)}
              >
                <i className="pi pi-pencil"></i>
              </button>
              <button
                type="button"
                title="Cancelar Lacre Unidade Carga"
                className="btn btn-danger"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleDeleteLacreUnidCarga(e)}
              >
                <i className="pi pi-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Ok Informação de carga do Transporte"
              className="btn btn-success"
              onClick={handleOkInfCargaUnidTransporte}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroInfCargaUnidTransporte(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Autorização XML"
        visible={showCadastroAutXml}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroAutXml()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CNPJ
              </Input155px>
              <InputText
                maxLength={14}
                value={autXmlCnpj}
                onChange={e => setAutXmlCnpj(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CPF
              </Input155px>
              <InputText
                maxLength={14}
                value={autXmlCpf}
                onChange={e => setAutXmlCpf(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkAutXml}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroAutXml(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - CIOT"
        visible={showCadastroCiot}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroCiot()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Código*
              </Input155px>
              <InputText
                maxLength={12}
                value={ciotCodigo}
                onChange={e => setCiotCodigo(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CNPJ/CPF
              </Input155px>
              <InputText
                maxLength={14}
                value={ciotCnpj}
                onChange={e => setCiotCnpj(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkCiot}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroCiot(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Doc Fiscal Transporte"
        visible={showCadastroDocFiscalTransporte}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroDocFiscalTransporte()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Tipo Unidade Transporte*
              </Input200px>
              <Dropdown
                options={listaMdfeTipoUnidTrasnporteDocFiscal}
                value={transpTpUnid}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTranspTpUnid(e.target.value)}
              />
            </div>
          </div>
          <div className="col-8">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Identificação*
              </Input155px>
              <InputText
                maxLength={20}
                value={transpIdUnid}
                onChange={e => setTranspIdUnid(e.target.value)}
              />
            </div>
          </div>
        </div>
        <TabView activeIndex={activeTabDocFiscalTransporteIndex} scrollable onTabChange={(e) => setActiveTabDocFiscalTransporteIndex(e.index)}>
          <TabPanel header="Lacres">
            <div className="row form-elo">
              <div className="lacres">
                <DataTable
                  header="Lacres Unidade Transporte - Inclusão"
                  value={listaLacreUnidTransporte}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedLacreUnidTransporte}
                  onSelectionChange={e => setSelectedLacreUnidTransporte(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupLacreUnidTransporte)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Lacre Unidade Transporte"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoLacreUnidTransporte(0);
                      limparCamposLacreUnidTransporte(true);
                      setShowCadastroLacreUnidTransporte(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Lacre Unidade Transporte"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditLacreUnidTransporte(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Lacre Unidade Transporte"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteLacreUnidTransporte(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Informações das Unidades de Carga">
            <div className="row form-elo">
              <div className="Informações das Unidades de Carga">
                <DataTable
                  header="Informações das Unidades de Carga - Inclusão"
                  value={listaInfCargaUnidTransporte}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedInfCargaUnidTransporte}
                  onSelectionChange={e => setSelectedInfCargaUnidTransporte(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupInfCargaUnidTransporte)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Informações Carga Unidade Transporte"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoInfCargaUnidTransporte(0);
                      limparCamposInfCargaUnidTransporte(true);
                      setShowCadastroInfCargaUnidTransporte(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Informação Carga Unidade Transporte"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditInfCargaUnidTransporte(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Lacre Unidade Transport"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteInfCargaUnidTransporte(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
        </TabView>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Ok Inclusão Doc Fiscal Transporte"
              className="btn btn-success"
              onClick={handleOkDocFiscalTransporte}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroDocFiscalTransporte(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Doc Fiscal Produto Perigoso"
        visible={showCadastroDocFiscalProdutosPerigosos}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroDocFiscalProdutosPerigosos()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Nº ONU/UN
              </Input155px>
              <InputText
                maxLength={4}
                value={docFiscalProdutoPerigosoOnu}
                onChange={e => setDocFiscalProdutoPerigosoOnu(e.target.value)}
              />
            </div>
          </div>
          <div className="col-8">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Classe e Risco
              </Input155px>
              <InputText
                title="Classe ou Subclasse/Divisão e Risco Subsidiário/Secundário"
                maxLength={40}
                value={docFiscalProdutoPerigosoClasse}
                onChange={e => setDocFiscalProdutoPerigosoClasse(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Nome Produto
              </Input155px>
              <InputText
                title="Nome Apropriado para Embarque do Produto"
                maxLength={150}
                value={docFiscalProdutoPerigosoNomeEmbarque}
                onChange={e => setDocFiscalProdutoPerigosoNomeEmbarque(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Grupo de Embalagem
              </Input200px>
              <InputText
                maxLength={6}
                value={docFiscalProdutoPerigosoGrupoEmbalagem}
                onChange={e => setDocFiscalProdutoPerigosoGrupoEmbalagem(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Qtde Total por Produto
              </Input200px>
              <InputText
                maxLength={20}
                value={docFiscalProdutoPerigosoQtdePorProduto}
                onChange={e => setDocFiscalProdutoPerigosoQtdePorProduto(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Qtde e Tipo de Volumes
              </Input200px>
              <InputText
                maxLength={60}
                value={docFiscalProdutoPerigosoQtdeETipoVolume}
                onChange={e => setDocFiscalProdutoPerigosoQtdeETipoVolume(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Inclusão Doc Fiscal Produto Perigoso"
              className="btn btn-success"
              onClick={handleOkDocFiscalProdutosPerigosos}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroDocFiscalProdutosPerigosos(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Doc Fiscal Carga"
        visible={showCadastroDocFiscalCarga}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroDocFiscalCarga()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Tipo Unidade Carga
              </Input200px>
              <Dropdown
                options={listaMdfeTipoUnidCargaDocFiscal}
                value={docFiscalUnidadeCargaTipo}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setDocFiscalUnidadeCargaTipo(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkDocFiscalCarga}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroDocFiscalCarga(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Doc Fiscal"
        visible={showCadastroDocFiscal}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroDocFiscal()}
      >
        <div className="row form-elo">
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Doc Fiscal*
              </Input155px>
              <Dropdown
                options={listaMdfeModeloDocFiscal}
                value={docFiscalModelo}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setDocFiscalModelo(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Chave Acesso*
              </Input155px>
              <InputText
                maxLength={44}
                value={docFiscalChaveAcesso}
                onChange={e => setDocFiscalChaveAcesso(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Reentrega
              </Input200px>
              <ToggleButton
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={docFiscalReentrega}
                onChange={(e) => setDocFiscalReentrega(e.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Segundo Cód. Barras
              </Input155px>
              <InputText
                maxLength={26}
                value={docFiscalSegundoCodigoBarras}
                onChange={e => setDocFiscalSegundoCodigoBarras(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <TabView activeIndex={activeTabDocFiscalIndex} scrollable onTabChange={(e) => setActiveTabDocFiscalIndex(e.index)}>
            <TabPanel header="Transporte">
              <div className="row form-elo">
                <div className="transporte">
                  <DataTable
                    header="Transporte - Inclusão"
                    value={listaDocFiscalTransporte}
                    size="small"
                    stripedRows
                    responsiveLayout="scroll"
                    sortField="item"
                    selectionMode="single"
                    selection={selectedDocFiscalTransporte}
                    onSelectionChange={e => setSelectedDocFiscalTransporte(e.value)}
                    selectableRows
                    dataKey="item"
                    emptyMessage="Nenhum Item cadastrado"
                  >
                    {fillColumns(columnsSetupDocFiscalTransporte)}
                  </DataTable>
                </div>
                <br />
                <div className="row form-elo">
                  <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <button
                      type="button"
                      title="Inclusão Doc Fiscal Transporte"
                      className="btn btn-success"
                      style={{ borderRadius: '15px' }}
                      onClick={() => {
                        setEditandoDocFiscalTransporte(0);
                        setShowCadastroDocFiscalTransporte(true);
                      }}
                    >
                      <i className="pi pi-plus"></i>
                    </button>
                    <button
                      type="button"
                      title="Alterar Doc Fiscal Transporte"
                      className="btn btn-warning"
                      style={{ borderRadius: '15px' }}
                      onClick={(e) => handleEditDocFiscalTransporte(e)}
                    >
                      <i className="pi pi-pencil"></i>
                    </button>
                    <button
                      type="button"
                      title="Cancelar Doc Fiscal Transporte"
                      className="btn btn-danger"
                      style={{ borderRadius: '15px' }}
                      onClick={(e) => handleDeleteDocFiscalTransporte(e)}
                    >
                      <i className="pi pi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Produtos Perigosos">
              <div className="row form-elo">
                <div className="transporte">
                  <DataTable
                    header="Produtos Perigosos - Inclusão"
                    value={listaDocFiscalProdutosPerigosos}
                    size="small"
                    stripedRows
                    responsiveLayout="scroll"
                    sortField="item"
                    selectionMode="single"
                    selection={selectedDocFiscalProdutosPerigosos}
                    onSelectionChange={e => setSelectedDocFiscalProdutosPerigosos(e.value)}
                    selectableRows
                    dataKey="item"
                    emptyMessage="Nenhum Item cadastrado"
                  >
                    {fillColumns(columnsSetupDocFiscalProdutosPerigosos)}
                  </DataTable>
                </div>
                <br />
                <div className="row form-elo">
                  <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <button
                      type="button"
                      title="Inclusão Doc Fiscal Produto Perigoso"
                      className="btn btn-success"
                      style={{ borderRadius: '15px' }}
                      onClick={() => {
                        setEditandoDocFiscalProdutosPerigosos(0);
                        limparCamposDocFiscalProdutosPerigosos(true);
                        setShowCadastroDocFiscalProdutosPerigosos(true);
                      }}
                    >
                      <i className="pi pi-plus"></i>
                    </button>
                    <button
                      type="button"
                      title="Alterar Doc Fiscal Produto Perigoso"
                      className="btn btn-warning"
                      style={{ borderRadius: '15px' }}
                      onClick={(e) => handleEditDocFiscalProdutosPerigosos(e)}
                    >
                      <i className="pi pi-pencil"></i>
                    </button>
                    <button
                      type="button"
                      title="Cancelar Doc Fiscal Produto Perigoso"
                      className="btn btn-danger"
                      style={{ borderRadius: '15px' }}
                      onClick={(e) => handleDeleteDocFiscalProdutosPerigosos(e)}
                    >
                      <i className="pi pi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Ok Doc Fiscal"
              className="btn btn-success"
              onClick={handleOkDocFiscal}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroDocFiscal(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Rodoviario - Vale Pedágio"
        visible={showCadastroValePedagio}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroValePedagio()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                CNPJ Fornecedor Vale Pedágio*
              </Input250px>
              <InputText
                maxLength={14}
                value={valePedagioCnpjForn}
                onChange={e => setValePedagioCnpjForn(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                CNPJ/CPF Pagador Vale Pedágio*
              </Input250px>
              <InputText
                maxLength={14}
                value={valePedagioCnpjPg}
                onChange={e => setValePedagioCnpjPg(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Número comprovante Vale Pedágio
              </Input250px>
              <InputText
                maxLength={14}
                value={valePedagioNCompra}
                onChange={e => setValePedagioNCompra(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Valor Vale Pedágio*
              </Input250px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                mode="currency"
                inputId="currency-br"
                currency="BRL"
                locale="pt-BR"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={valePedagioValor}
                onValueChange={e => setValePedagioValor(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkValePedagio}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroValePedagio(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Rodoviário - Pagamento Frete"
        visible={showCadastroInfPag}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroInfPag()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                CNPJ/CPF Responsável*
              </Input250px>
              <InputText
                maxLength={14}
                value={infPagCpfCnpjResponsavel}
                onChange={e => setInfPagCpfCnpjResponsavel(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Nome Responsável
              </Input250px>
              <InputText
                maxLength={60}
                value={infPagXNome}
                onChange={e => setInfPagXNome(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Id Estrangeiro
              </Input250px>
              <InputText
                maxLength={60}
                value={infPagIdEstrangeiro}
                onChange={e => setInfPagIdEstrangeiro(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Valor Contrato*
              </Input250px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                mode="currency"
                inputId="currency-br"
                currency="BRL"
                locale="pt-BR"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={infPagVContrato}
                onValueChange={e => setInfPagVContrato(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input400px className="p-inputgroup-addon">
                Operação de transporte de Alto Desempenho
              </Input400px>
              <ToggleButton
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={infPagIndAltoDesemp}
                onChange={(e) => setInfPagIndAltoDesemp(e.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Indicador de Forma de Pagamento
              </Input250px>
              <Dropdown
                options={listaMdfeIndPag}
                value={infPagIndPag}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setInfPagIndPag(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Valor Adiantamento
              </Input250px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                mode="currency"
                inputId="currency-br"
                currency="BRL"
                locale="pt-BR"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={infPagVAdiant}
                onValueChange={e => setInfPagVAdiant(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input400px className="p-inputgroup-addon">
                Concordância em Antecipar o Adiantamento
              </Input400px>
              <ToggleButton
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={infPagIndAntecipaAdiant}
                onChange={(e) => setInfPagIndAntecipaAdiant(e.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Permissão a antecipação das parcelas
              </Input250px>
              <Dropdown
                options={listaMdfeTpAntecip}
                value={infPagTpAntecip}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setInfPagTpAntecip(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Cód. Banco*
              </Input100px>
              <InputText
                maxLength={5}
                value={infPagCodBanco}
                onChange={e => setInfPagCodBanco(e.target.value)}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Cód. Agência*
              </Input100px>
              <InputText
                maxLength={10}
                value={infPagCodAgencia}
                onChange={e => setInfPagCodAgencia(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                CNPJ Instituição Pg
              </Input200px>
              <InputText
                maxLength={14}
                value={infPagCnpjIpfe}
                onChange={e => setInfPagCnpjIpfe(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Chave PIX
              </Input200px>
              <InputText
                maxLength={60}
                value={infPagPix}
                onChange={e => setInfPagPix(e.target.value)}
              />
            </div>
          </div>
        </div>
        <TabView activeIndex={activeTabInfPagComponenteIndex} scrollable onTabChange={(e) => setActiveTabInfPagComponenteIndex(e.index)}>
          <TabPanel header="Componentes do Pagamento">
            <div className="row form-elo">
              <div className="pagamento-componente">
                <DataTable
                  header="Componente Pagamento Frete - Inclusão"
                  value={listaInfPagComponente}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedInfPagComponente}
                  onSelectionChange={e => setSelectedInfPagComponente(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupInfPagComponente)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Componente Pagamento Frete"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoInfPagComponente(0);
                      limparCamposInfPagComponente(true);
                      setShowCadastroInfPagComponente(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Componente Pagamento Frete"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditInfPagComponente(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Componente Pagamento Frete"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteInfPagComponente(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Informações do Pagamento a Prazo">
            <div className="row form-elo">
              <div className="pagamento-infprazo">
                <DataTable
                  header="Informações do Pagamento a Prazo - Inclusão"
                  value={listaInfPagInfPrazo}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedInfPagInfPrazo}
                  onSelectionChange={e => setSelectedInfPagInfPrazo(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupInfPagInfPrazo)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Informações do Pagamento a Prazo"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoInfPagInfPrazo(0);
                      limparCamposInfPagInfPrazo(true);
                      setShowCadastroInfPagInfPrazo(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Informações do Pagamento a Prazo"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditInfPagInfPrazo(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Informações do Pagamento a Prazo"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteInfPagInfPrazo(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
        </TabView>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Ok Rodoviário - Pagamento Frete"
              className="btn btn-success"
              onClick={handleOkInfPag}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroInfPag(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Pagamento Frete - Componente"
        visible={showCadastroInfPagComponente}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroInfPagComponente()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Tipo Componente
              </Input200px>
              <Dropdown
                options={listaMdfeTpComp}
                value={infPagTpComp}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setInfPagTpComp(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Valor Componente
              </Input200px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                mode="currency"
                inputId="currency-br"
                currency="BRL"
                locale="pt-BR"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={infPagVComp}
                onValueChange={e => setInfPagVComp(e.target.value)}
              />
            </div>
          </div>
          <div className="col-5">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Descrição do Componente
              </Input200px>
              <InputText
                maxLength={60}
                value={infPagXComp}
                onChange={e => setInfPagXComp(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkInfPagComponente}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroInfPagComponente(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Pagamento Frete - Informação Prazo"
        visible={showCadastroInfPagInfPrazo}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroInfPagInfPrazo()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Vencimento
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                showTime
                hourFormat="24"
                showSeconds
                mask="99/99/9999 99:99:99"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={infPagInfPrazoDVenc}
                onChange={(e) => setInfPagInfPrazoDVenc(e.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Número da parcela
              </Input200px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                max={3}
                minFractionDigits={0}
                maxFractionDigits={0}
                value={infPagInfPrazoNParcela}
                onValueChange={e => setInfPagInfPrazoNParcela(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Valor Parcela
              </Input200px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                mode="currency"
                inputId="currency-br"
                currency="BRL"
                locale="pt-BR"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={infPagInfPrazoVParcela}
                onValueChange={e => setInfPagInfPrazoVParcela(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Ok Informação do Prazo"
              className="btn btn-success"
              onClick={handleOkInfPagInfPrazo}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroInfPagInfPrazo(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Contratante"
        visible={showCadastroContratante}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroContratante()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CNPJ
              </Input155px>
              <InputText
                maxLength={14}
                value={contratanteCnpj}
                onChange={e => setContratanteCnpj(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CPF
              </Input155px>
              <InputText
                maxLength={14}
                value={contratanteCpf}
                onChange={e => setContratanteCpf(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkContratante}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroContratante(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Reboque"
        visible={showCadastroReboque}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroReboque()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Reboque
              </Input155px>
              <Button
                icon="pi pi-search"
                className="p-button-warning"
                onClick={() => setShowConsultaReboque(true)}
              />
              <Button
                icon="pi pi-trash"
                className="p-button-danger"
                onClick={() => limparReboque()}
              />
              <InputText
                disabled
                maxLength={255}
                value={placaReboque}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkReboque}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroReboque(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="MDF-e - Seguro Carga"
        visible={showCadastroSeguroCarga}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroSeguroCarga()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Responsável
              </Input100px>
              <Dropdown
                options={listaRespSeguro}
                value={seguroResponsavel}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setSeguroResponsavel(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CNPJ/CPF Responsável
              </Input155px>
              <InputText
                maxLength={14}
                value={seguroCnpjResponsavel}
                onChange={e => setSeguroCnpjResponsavel(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Nome Seguradora
              </Input155px>
              <InputText
                maxLength={30}
                value={seguroNomeSeguradora}
                onChange={e => setSeguroNomeSeguradora(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CNPJ Seguradora
              </Input155px>
              <InputText
                maxLength={14}
                value={seguroCnpjSeguradora}
                onChange={e => setSeguroCnpjSeguradora(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número Apólice
              </Input155px>
              <InputText
                maxLength={20}
                value={seguroNumeroApolice}
                onChange={e => setSeguroNumeroApolice(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="row form-elo">
            <div className="ufs-percurso">
              <DataTable
                header="Averbação - Inclusão"
                value={listaAverbacao}
                size="small"
                stripedRows
                responsiveLayout="scroll"
                sortField="item"
                selectionMode="single"
                selection={selectedAverbacao}
                onSelectionChange={e => setSelectedAverbacao(e.value)}
                selectableRows
                dataKey="item"
                emptyMessage="Nenhum Item cadastrado"
              >
                {fillColumns(columnsSetupAverbacao)}
              </DataTable>
            </div>
            <br />
            <div className="row form-elo">
              <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <button
                  type="button"
                  title="Inclusão Averbação"
                  className="btn btn-success"
                  style={{ borderRadius: '15px' }}
                  onClick={() => {
                    setEditandoAverbacao(0);
                    limparCamposAverbacao(true);
                    setShowCadastroAverbacao(true);
                  }}
                >
                  <i className="pi pi-plus"></i>
                </button>
                <button
                  type="button"
                  title="Alterar Averbação"
                  className="btn btn-warning"
                  style={{ borderRadius: '15px' }}
                  onClick={(e) => handleEditAverbacao(e)}
                >
                  <i className="pi pi-pencil"></i>
                </button>
                <button
                  type="button"
                  title="Cancelar Averbação"
                  className="btn btn-danger"
                  style={{ borderRadius: '15px' }}
                  onClick={(e) => handleDeleteAverbacao(e)}
                >
                  <i className="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkSeguroCarga}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroSeguroCarga(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteAutXml}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterAutXml}
        onHide={() => setShowConfirmDeleteAutXml(false)}
      >
        <p>
          Excluir o CNPJ/CPF autorizado?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteCiot}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterCiot}
        onHide={() => setShowConfirmDeleteCiot(false)}
      >
        <p>
          Excluir o CIOT?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteDocFiscalTransporte}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDocFiscalTransporte}
        onHide={() => setShowConfirmDeleteDocFiscalTransporte(false)}
      >
        <p>
          Excluir o Transporte?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteDocFiscalProdutosPerigosos}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDocFiscalProdutosPerigosos}
        onHide={() => setShowConfirmDeleteDocFiscalProdutosPerigosos(false)}
      >
        <p>
          Excluir o Produto Perigoso?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteDocFiscalCarga}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDocFiscalCarga}
        onHide={() => setShowConfirmDeleteDocFiscalCarga(false)}
      >
        <p>
          Excluir a Carga?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteDocFiscal}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDocFiscal}
        onHide={() => setShowConfirmDeleteDocFiscal(false)}
      >
        <p>
          Excluir o Doc. Fiscal?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteReboque}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterReboque}
        onHide={() => setShowConfirmDeleteReboque(false)}
      >
        <p>
          Excluir o Reboque?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteContratante}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterContratante}
        onHide={() => setShowConfirmDeleteContratante(false)}
      >
        <p>
          Excluir o Contratante?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteValePedagio}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterValePedagio}
        onHide={() => setShowConfirmDeleteValePedagio(false)}
      >
        <p>
          Excluir o Vale Pedágio?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteInfPag}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterInfPag}
        onHide={() => setShowConfirmDeleteInfPag(false)}
      >
        <p>
          Excluir o Pagamento Frete?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteInfPagComponente}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterInfPagComponente}
        onHide={() => setShowConfirmDeleteInfPagComponente(false)}
      >
        <p>
          Excluir o componente do Pagamento Frete?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteInfPagInfPrazo}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterInfPagInfPrazo}
        onHide={() => setShowConfirmDeleteInfPagInfPrazo(false)}
      >
        <p>
          Excluir o a informação do Pagamento a prazo?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação Cancelamento da digitação da MDF-e"
        visible={showConfirmCancelarDigitacaoMdfe}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterCancelarDigitacaoMdfe}
        onHide={() => showConfirmCancelarDigitacaoMdfe(false)}
      >
        <p>
          Deseja realmente cancelar a digitação da MDF-e?
        </p>
      </Dialog>

      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}>{titulo()}</h6>
        </div>
        <div className="row form-elo">
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Série*
              </Input155px>
              <InputNumber
                disabled
                onFocus={(e) => e.target.select()}
                maxFractionDigits={0}
                value={serie}
                onValueChange={e => {
                  setSerie(e.target.value);
                  propsTipoMovimentacao !== 'entrada' ? setUltimoNumero(e.target.value) : '';
                }}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número*
              </Input155px>
              <InputNumber
                disabled={disableEdicaoEnviada}
                onFocus={(e) => e.target.select()}
                maxFractionDigits={0}
                value={numeroMdf}
                onValueChange={e => setNumeroMdf(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data Emissão*
              </Input155px>
              <Calendar
                disabled={disableEdicaoEnviada}
                id="mask"
                showIcon
                showTime
                hourFormat="24"
                showSeconds
                mask="99/99/9999 99:99:99"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={dhEmi}
                onChange={(e) => setDhEmi(e.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Emissão*
              </Input155px>
              <Dropdown
                disabled
                options={listaMdfeTipoEmissao}
                value={tipoEmissao}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTipoEmissao(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                UF Início*
              </Input155px>
              <Dropdown
                options={listaUf}
                value={ufInicio}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setUfInicio(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                UF Fim*
              </Input155px>
              <Dropdown
                options={listaUf}
                value={ufFim}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setUfFim(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Modalidade*
              </Input155px>
              <Dropdown
                disabled
                options={listaMdfeModalidade}
                value={modalidade}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setModalidade(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data Viagem
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                showTime
                hourFormat="24"
                showSeconds
                mask="99/99/9999 99:99:99"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={dhIniViagem}
                onChange={(e) => setDhIniViagem(e.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Transportador
              </Input155px>
              <Dropdown
                options={listaMdfeTipoTransportador}
                value={tipoTransportador}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTipoTransportador(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Emitente*
              </Input155px>
              <Dropdown
                options={listaMdfeTipoEmitente}
                value={tipoEmitente}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTipoEmitente(e.target.value)}
              />
            </div>
          </div>
        </div>
        <TabView activeIndex={activeTabIndex} scrollable onTabChange={(e) => setActiveTabIndex(e.index)}>
          <TabPanel header="Municípios de Carregamento">
            <div className="row form-elo">
              <div className="municipio-carregamento">
                <DataTable
                  header="Município Carregamento - Inclusão"
                  value={listaMunicipioCarrega}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedMunicipioCarrega}
                  onSelectionChange={e => setSelectedMunicipioCarrega(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupMunicipioCarrega)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Município Carregamento"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoMunicipioCarrega(0);
                      limparCamposMunicipioCarrega(true);
                      setShowCadastroMunicipioCarrega(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Município Carregamento"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditMunicipioCarrega(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Município Carregamento"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteMunicipioCarrega(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Municípios de Descarregamento">
            <div className="row form-elo">
              <div className="municipio-descarregamento">
                <DataTable
                  header="Município Descarregamento - Inclusão"
                  value={listaMunicipioDescarga}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedMunicipioDescarga}
                  onSelectionChange={e => setSelectedMunicipioDescarga(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupMunicipioDescarga)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Município Descarregamento"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoMunicipioDescarga(0);
                      limparCamposMunicipioDescarga(true);
                      setShowCadastroMunicipioDescarga(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Município Descarregamento"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditMunicipioDescarga(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Município Descarregamento"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteMunicipioDescarga(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Rodoviário">
            <div className="row form-elo">
              <div className="col-6">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    RNTRC
                  </Input155px>
                  <InputText
                    maxLength={8}
                    value={rntrc}
                    onChange={e => setRntrc(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Veículo
                  </Input155px>
                  <Button
                    icon="pi pi-search"
                    className="p-button-warning"
                    onClick={() => setShowConsultaVeiculo(true)}
                  />
                  <Button
                    icon="pi pi-trash"
                    className="p-button-danger"
                    onClick={() => limparVeiculo()}
                  />
                  <InputText
                    disabled
                    maxLength={255}
                    value={placaVeiculo}
                  />
                </div>
              </div>
            </div>
            <TabView activeIndex={activeTabRodoviarioIndex} scrollable onTabChange={(e) => setActiveTabRodoviarioIndex(e.index)}>
              <TabPanel header="CIOT - Código Identificador da Operação de Transporte">
                <div className="row form-elo">
                  <div className="ciot">
                    <DataTable
                      header="CIOT - Inclusão"
                      value={listaCiot}
                      size="small"
                      stripedRows
                      responsiveLayout="scroll"
                      sortField="item"
                      selectionMode="single"
                      selection={selectedCiot}
                      onSelectionChange={e => setSelectedCiot(e.value)}
                      selectableRows
                      dataKey="item"
                      emptyMessage="Nenhum Item cadastrado"
                    >
                      {fillColumns(columnsSetupCiot)}
                    </DataTable>
                  </div>
                  <br />
                  <div className="row form-elo">
                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        type="button"
                        title="Inclusão CIOT"
                        className="btn btn-success"
                        style={{ borderRadius: '15px' }}
                        onClick={() => {
                          setEditandoCiot(0);
                          limparCamposCiot(true);
                          setShowCadastroCiot(true);
                        }}
                      >
                        <i className="pi pi-plus"></i>
                      </button>
                      <button
                        type="button"
                        title="Alterar CIOT"
                        className="btn btn-warning"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleEditCiot(e)}
                      >
                        <i className="pi pi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        title="Cancelar CIOT"
                        className="btn btn-danger"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleDeleteCiot(e)}
                      >
                        <i className="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Vale Pedágio">
                <div className="row form-elo">
                  <div className="vale-pedagio">
                    <DataTable
                      header="Vale Pedágio - Inclusão"
                      value={listaValePedagio}
                      size="small"
                      stripedRows
                      responsiveLayout="scroll"
                      sortField="item"
                      selectionMode="single"
                      selection={selectedValePedagio}
                      onSelectionChange={e => setSelectedValePedagio(e.value)}
                      selectableRows
                      dataKey="item"
                      emptyMessage="Nenhum Item cadastrado"
                    >
                      {fillColumns(columnsSetupValePedagio)}
                    </DataTable>
                  </div>
                  <br />
                  <div className="row form-elo">
                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        type="button"
                        title="Inclusão Vale Pedágio"
                        className="btn btn-success"
                        style={{ borderRadius: '15px' }}
                        onClick={() => {
                          setEditandoValePedagio(0);
                          limparCamposValePedagio(true);
                          setShowCadastroValePedagio(true);
                        }}
                      >
                        <i className="pi pi-plus"></i>
                      </button>
                      <button
                        type="button"
                        title="Alterar Vale Pedágio"
                        className="btn btn-warning"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleEditValePedagio(e)}
                      >
                        <i className="pi pi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        title="Cancelar Vale Pedágio"
                        className="btn btn-danger"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleDeleteValePedagio(e)}
                      >
                        <i className="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Informações do Pagamento do Frete">
                <div className="row form-elo">
                  <div className="pagamento-frete">
                    <DataTable
                      header="Pagamento Frete - Inclusão"
                      value={listaInfPag}
                      size="small"
                      stripedRows
                      responsiveLayout="scroll"
                      sortField="item"
                      selectionMode="single"
                      selection={selectedInfPag}
                      onSelectionChange={e => setSelectedInfPag(e.value)}
                      selectableRows
                      dataKey="item"
                      emptyMessage="Nenhum Item cadastrado"
                    >
                      {fillColumns(columnsSetupInfPag)}
                    </DataTable>
                  </div>
                  <br />
                  <div className="row form-elo">
                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        type="button"
                        title="Inclusão Pagamento Frete"
                        className="btn btn-success"
                        style={{ borderRadius: '15px' }}
                        onClick={() => {
                          setEditandoInfPag(0);
                          limparCamposInfPag(true);
                          setShowCadastroInfPag(true);
                        }}
                      >
                        <i className="pi pi-plus"></i>
                      </button>
                      <button
                        type="button"
                        title="Alterar Pagamento Frete"
                        className="btn btn-warning"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleEditInfPag(e)}
                      >
                        <i className="pi pi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        title="Cancelar Pagamento Frete"
                        className="btn btn-danger"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleDeleteInfPag(e)}
                      >
                        <i className="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Contratantes">
                <div className="row form-elo">
                  <div className="contratantes">
                    <DataTable
                      header="Contratantes - Inclusão"
                      value={listaContratante}
                      size="small"
                      stripedRows
                      responsiveLayout="scroll"
                      sortField="item"
                      selectionMode="single"
                      selection={selectedContratante}
                      onSelectionChange={e => setSelectedContratante(e.value)}
                      selectableRows
                      dataKey="item"
                      emptyMessage="Nenhum Item cadastrado"
                    >
                      {fillColumns(columnsSetupContratante)}
                    </DataTable>
                  </div>
                  <br />
                  <div className="row form-elo">
                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        type="button"
                        title="Inclusão Contratante"
                        className="btn btn-success"
                        style={{ borderRadius: '15px' }}
                        onClick={() => {
                          setEditandoContratante(0);
                          limparCamposContratante(true);
                          setShowCadastroContratante(true);
                        }}
                      >
                        <i className="pi pi-plus"></i>
                      </button>
                      <button
                        type="button"
                        title="Alterar Contratante"
                        className="btn btn-warning"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleEditContratante(e)}
                      >
                        <i className="pi pi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        title="Cancelar Contratante"
                        className="btn btn-danger"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleDeleteContratante(e)}
                      >
                        <i className="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Reboques">
                <div className="row form-elo">
                  <div className="reboques">
                    <DataTable
                      header="Reboques - Inclusão"
                      value={listaReboque}
                      size="small"
                      stripedRows
                      responsiveLayout="scroll"
                      sortField="item"
                      selectionMode="single"
                      selection={selectedReboque}
                      onSelectionChange={e => setSelectedReboque(e.value)}
                      selectableRows
                      dataKey="item"
                      emptyMessage="Nenhum Item cadastrado"
                    >
                      {fillColumns(columnsSetupReboque)}
                    </DataTable>
                  </div>
                  <br />
                  <div className="row form-elo">
                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        type="button"
                        title="Inclusão Reboque"
                        className="btn btn-success"
                        style={{ borderRadius: '15px' }}
                        onClick={() => {
                          setEditandoReboque(0);
                          limparCamposReboque(true);
                          setShowCadastroReboque(true);
                        }}
                      >
                        <i className="pi pi-plus"></i>
                      </button>
                      <button
                        type="button"
                        title="Alterar Reboque"
                        className="btn btn-warning"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleEditReboque(e)}
                      >
                        <i className="pi pi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        title="Cancelar Reboque"
                        className="btn btn-danger"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleDeleteReboque(e)}
                      >
                        <i className="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel>
              { /* <TabPanel header="Lacres Unid. Transporte">
                <div className="row form-elo">
                  <div className="lacres">
                    <DataTable
                      header="Lacres - Inclusão"
                      value={listaMDFeLacre}
                      size="small"
                      stripedRows
                      responsiveLayout="scroll"
                      sortField="item"
                      selectionMode="single"
                      selection={selectedMDFeLacre}
                      onSelectionChange={e => setSelectedMDFeLacre(e.value)}
                      selectableRows
                      dataKey="item"
                      emptyMessage="Nenhum Item cadastrado"
                    >
                      {fillColumns(columnsSetupMDFeLacre)}
                    </DataTable>
                  </div>
                  <br />
                  <div className="row form-elo">
                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        type="button"
                        title="Inclusão Lacre Unidade Transporte"
                        className="btn btn-success"
                        style={{ borderRadius: '15px' }}
                        onClick={() => {
                          setEditandoMDFeLacre(0);
                          limparCamposMDFeLacre(true);
                          setShowCadastroMDFeLacre(true);
                        }}
                      >
                        <i className="pi pi-plus"></i>
                      </button>
                      <button
                        type="button"
                        title="Alterar Lacre"
                        className="btn btn-warning"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleEditMDFeLacre(e)}
                      >
                        <i className="pi pi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        title="Cancelar Lacre"
                        className="btn btn-danger"
                        style={{ borderRadius: '15px' }}
                        onClick={(e) => handleDeleteMDFeLacre(e)}
                      >
                        <i className="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel> */}
            </TabView>
          </TabPanel>
          <TabPanel header="UFs Percurso">
            <div className="row form-elo">
              <div className="ufs-percurso">
                <DataTable
                  header="UF Percurso - Inclusão"
                  value={listaUfPercurso}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedUfPercurso}
                  onSelectionChange={e => setSelectedUfPercurso(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupUfPercurso)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão UF Percurso"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoUfPercurso(0);
                      limparCamposUfPercurso(true);
                      setShowCadastroUfPercurso(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar UF Percurso"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditUfPercurso(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar UF Percurso"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteUfPercurso(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Lacres MDF-e">
            <div className="row form-elo">
              <div className="lacres">
                <DataTable
                  header="Lacres - Inclusão"
                  value={listaMDFeLacre}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedMDFeLacre}
                  onSelectionChange={e => setSelectedMDFeLacre(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupMDFeLacre)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Lacre MDF-e"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoMDFeLacre(0);
                      limparCamposMDFeLacre(true);
                      setShowCadastroMDFeLacre(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Lacre MDF-e"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditMDFeLacre(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Excluir Lacre MDF-e"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteMDFeLacre(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Seguro Carga">
            <div className="row form-elo">
              <div className="seguro-carga">
                <DataTable
                  header="Seguro Carga - Inclusão"
                  value={listaSeguroCarga}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedSeguroCarga}
                  onSelectionChange={e => setSelectedSeguroCarga(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupSeguroCarga)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Seguro Carga"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoSeguroCarga(0);
                      limparCamposSeguroCarga(true);
                      setShowCadastroSeguroCarga(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Seguro Carga"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditSeguroCarga(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Seguro Carga"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteSeguroCarga(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Outras informações">
            <div className="row form-elo">
              <div className="col-12">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Infor. Complementar da NF
                  </Input200px>
                  <InputText
                    disabled={disableEdicaoEnviada}
                    maxLength={5000}
                    value={infCpl}
                    onChange={e => setInfCpl(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-12">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Infor. de Interesse do Fisco
                  </Input200px>
                  <InputText
                    disabled={disableEdicaoEnviada}
                    maxLength={2000}
                    value={infAdFisco}
                    onChange={e => setInfAdFisco(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Autorização XML">
            <div className="row form-elo">
              <div className="aut-xml">
                <DataTable
                  header="Autorização XML - Inclusão"
                  value={listaAutXml}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedAutXml}
                  onSelectionChange={e => setSelectedAutXml(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupAutXml)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Autorização XML"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoAutXml(0);
                      limparCamposAutXml(true);
                      setShowCadastroAutXml(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar autorização XML"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditAutXml(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Autorização XML"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteAutXml(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
        </TabView>
        <div className="row float-end">
          <div className="col-lg-12 ">
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-success"
            >
              <i className="pi pi-check"></i>
              Salvar
            </button>
            <button
              onClick={handleCancel}
              type="button"
              className="btn btn-danger"
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}
